/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import Modals from "../../../components/common/Modal";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import { Card, Form, Modal } from "react-bootstrap";
import { resolveTimeFormat } from "@mui/x-date-pickers/internals/utils/time-utils";
import { uploadedFileDownload } from "../../uploadDocument/UploadedFileDownload";
import * as Yup from "yup";
import { ErrorMessage, Formik } from "formik";
import Base64ToExcelDownload from "../../Base64ToExcelDownload";
import UploadMultipleDocuments from "../../uploadDocument/UploadMultipleDocuments";
import {
  AiOutlineFile,
  AiOutlineFileImage,
  AiOutlineFilePdf,
  AiOutlineFileText,
} from "react-icons/ai";
import { useDispatch } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import {
  getAllAuctionCenterAscAction,
  getAllStateAscAction,
  createUserRequest,
  createWarehouseUnitRequest,
  createWarehouseUserRequest,
  fetchAuctionRequest,
  fetchDocumentsRequest,
  fetchStateRequest,
  fetchUnitDocumentsRequest,
  getDocumentDetailRequest,
  getUnitRequest,
  getUserRequest,
  getUsersRequest,
  getWarehouseHistoryRequest,
  getWarehouseUnitHistoryRequest,
  postWarehouseUserRequest,
  postWarehouseUserSuccess,
  searchUnitRequest,
  searchUsersRequest,
  searchWarehouseUnitsSuccess,
  updateWarehouseUnitRequest,
  updateWarehouseUserRequest,
  getHistoryByIdAction,
  getDocumentByIdAction,
  createEditApiStatusWarehouse,
  getExportDataForView,
  getExportDataForViewApiCall,
  closemodel,
  createWarehouseDisable,
  gstVerificationRequest,
  getBuyer,
  ResetPassWordByAdminAction,
  getDocumentByIdActionSuccess,
  getExportData,
} from "../../../store/actions";
import { useSelector } from "react-redux";
import WarehouseHistory from "./warehouseHistory";
import WarehouseUnitHistory from "./WarehouseUnitHistory";
import CustomToast from "../../../components/Toast";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import { NO_OF_RECORDS } from "../../../constants/commonConstants";
import { Tooltip } from "@mui/material";
import debounce from "lodash.debounce";
import UserTable from "../../../components/tableComponent/UserTable";
import moment from "moment";
import Base64ToPDFPreview from "../../uploadDocument/Base64ToPDFPreview";
import axiosMain from "../../../http/axios/axios_main";
import { useAuctionDetail } from "../../../components/common/AunctioneerDeteailProvider";

let pageNo = 1;
function WarehouseUserRegistration({ modalRight, childUser, isProfile }) {
  const [expanded, setExpanded] = React.useState("panel1");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [expandedSub, setExpandedSub] = React.useState("panel1");
  const [auctionCenterList, setAuctionCenterList] = useState([]);
  const [auctionCenterLists, setAuctionCenterLists] = useState([]);
  const dispatch = useDispatch();
  const handleChangeExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    if ("panel1" == panel && isExpanded) {
      resetForm();
    }

    if ("panel2" == panel && isExpanded) {
      dispatch(
        getBuyer({
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
          userType: 71,
          isParentId: 0,
          roleCode: "WAREHOUSE",
        })
      );
    }
  };

  const currentYear = moment().year();

  const handleChangeExpandSub = (panel) => (event, isSubExpanded) => {
    setExpandedSub(isSubExpanded ? panel : false);
    if ("panel2" == panel && isSubExpanded) {
      resetFormUnit();
    }
  };
  const [exportViewType, setexportViewType] = useState("");
  const [exportUnitViewType, setexportUnitViewType] = useState("");
  const [AuctionCenter, setAuctionCenter] = useState([]);
  const [StateList, setStateList] = useState([]);
  const [StateCode, setStateCode] = useState([]);
  const [RegUsers, setRegUsers] = useState([]);
  const [isEdit, setIsedit] = useState(false);
  const [UploadedDocuemnt, setUploadedDocument] = useState([]);
  const [userId, setUserId] = useState("");
  const [downlodDocument, setDownloadDocument] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [field, setField] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);
  const [uploadedDocumentsForUnit, setUploadedDocumentsForUnit] = useState([]);
  const [uploadDocumentError, setUploadDocumentError] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFilesUnit, setUploadedFilesUnit] = useState([]);
  const [showmodal, setShowmodal] = useState(false);
  const [showmodalWarehouseHistory, setShowmodalWarehouseHistory] =
    useState(false);
  const [showmodalWarehouseUnitHistory, setShowmodalWarehouseUnitHistory] =
    useState(false);
  const [unitsearch, setUnitSearch] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [unitSearchData, setUnitSearchData] = useState([]);
  const [isUnitEdit, setisUnitEdit] = useState([]);
  const [isUnitAdd, setisUnitAdd] = useState(true);
  const [isViewUnit, setViewUnit] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewDocumentContent, setPreviewDocumentContent] = useState("");

  const [warehouseDisabled, setwarehouseDisabled] = useState(false);
  const SubUSerClose = () => setShowmodal(false);
  const WarehouseHistoryClose = () => setShowmodalWarehouseHistory(false);
  const WarehouseHistoryUnitClose = () => showmodalWarehouseUnitHistory(false);
  const [auctionCenterId, setauctionCenterId] = useState("");
  const [clear, setclear] = useState({});
  const [OLDDataList, setOLDDataList] = useState();
  const [auctioneerGstDtoList, setauctioneerGstDtoList] = useState([]);
  const [onChangesAuctionCenterId, setOnChangeAuctionCenterId] = useState([]);
  const [auctionCenterIdError, setauctionCenterIdError] = useState("");
  const [tblState, settblState] = useState("");
  const [viewWarehouseModal, setViewWarehouseModal] = useState(false);
  const [editWarehouseModal, setEditWarehouseModal] = useState(false);
  const [viewWarehouseUnitModal, setViewWarehouseUnitModal] = useState(false);
  const [editWarehouseUnitModal, setEditWarehouseUnitModal] = useState(false);
  const [irnEligibility, setIrnEligibility] = useState(0);
  const [declarationCheck, setDeclarationCheck] = useState(0);
  const [optionsForYear, setOptionsForYear] = useState([]);
  const userRoleCode = atob(localStorage.getItem("argument6"));
  const [viewpdf, setviewpdf] = useState(false);
  const [formData, setFormData] = useState({
    uploadDocumentRemarks: "",
    wareHouseName: "",
    wareHouseCode: "",
    roleCode: "WAREHOUSE",
    // wareHouseLicenseNo: "",

    contactPerson: "",
    email: "",
    panNo: "",
    wareHouseGstDtoList: [],
    isActive: 1,
    irnEligibility: 0,
  });

  const userLoggedInId =
    window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[3]
      ? atob(
          window.location.pathname &&
            window.location.pathname.split("/") &&
            window.location.pathname.split("/")[3]
        )
      : "";

  const columnsData = [
    // { title: "Sr No.", name: "srNo", checkbox: false, noneditable: true, dropdown: false },
    {
      title: "Auction Center",
      name: "auctionCenterName",
      checkbox: false,
      noneditable: true,
      dropdown: false,
    },
    {
      title: "State",
      name: "stateName",
      checkbox: false,
      noneditable: true,
      dropdown: false,
    },
    {
      title: "CENTER WISE GSTNo",
      name: "gstNo",
      checkbox: false,
      noneditable: false,
      dropdown: false,
      mandatory: true,
      validationMessage: "Please enter GST No.",
    },
    {
      title: "Address",
      name: "address",
      checkbox: true,
      noneditable: false,
      dropdown: false,
      mandatory: true,
      validationMessage: "Please enter an address.",
    },
    // { title: "Head Office Address", name: "address", checkbox: true, noneditable: false, dropdown: false },
    {
      title: "City",
      name: "city",
      checkbox: true,
      noneditable: false,
      dropdown: false,
      mandatory: true,
    },
    {
      title: "Phone",
      name: "phoneNo",
      checkbox: true,
      noneditable: false,
      dropdown: false,
      mandatory: false,
    },
    {
      title: "Center Wise Email ID",
      name: "emailId",
      checkbox: true,
      noneditable: false,
      dropdown: false,
      mandatory: true,
    },
    {
      title: "Mobile No.",
      name: "mobileNo",
      checkbox: true,
      noneditable: false,
      dropdown: false,
      maxLength: 10,
      mandatory: true,
    },
    {
      title: "FAX",
      name: "fax",
      checkbox: true,
      noneditable: false,
      dropdown: false,
    },
    {
      title: "CIN Number",
      name: "cinNo",
      checkbox: false,
      noneditable: false,
      dropdown: false,
    },
    // { title: "Legal Name", name: "legalName", checkbox: true, noneditable: false, dropdown: false },
    // { title: "Pincode", name: "pincode", checkbox: true, noneditable: false, dropdown: false },
    // { title: "Service Tax No", name: "serviceTaxNo", checkbox: true, noneditable: false, dropdown: false },
    // { title: "CIN Number", name: "cinNumber", checkbox: true, noneditable: false, dropdown: false },
    // { title: "Year of Registration", name: "yearOfRegistration", checkbox: false, noneditable: false, dropdown: true, options: optionsForYear },
    {
      title: "ShortName",
      name: "shortName",
      checkbox: true,
      noneditable: false,
      dropdown: false,
      mandatory: true,
    },
    {
      title: "Center Wise Tea board Rag. No/ Ware House License No",
      name: "teaBoardRegistrationNo",
      checkbox: true,
      noneditable: false,
      dropdown: false,
      mandatory: true,
      validationMessage:
        "Please enter the Center Wise Tea board Rag. No/ Ware House License No.",
    },
    {
      title: "TaxId No",
      name: "taxIdNo",
      checkbox: true,
      noneditable: false,
      dropdown: false,
    },
    // {
    //   title: "Werehouse License No",
    //   name: "wareHouseLicenseNo",
    //   checkbox: true,
    //   noneditable: false,
    //   dropdown: false,
    //   // mandatory: true,
    // },
    // { title: "FSSAI No", name: "fssaiNo", checkbox: true, noneditable: false, dropdown: false },
    // { title: "Bank Account Detail Status", name: "bankAccountDetailStatus", checkbox: false, noneditable: true, dropdown: false, fixValue: true, fixedColumnValue: "VERIFIED" },
  ];

  console.log(RegUsers, "😜😜😜");

  useEffect(() => {
    if (expanded === "panel2") {
      // handleSearch()
      setRegUsers([]);
      pageNo = 1;
      setLoader(true);
      // dispatch(
      //   searchUsersRequest({
      //     ...searchData,
      //     pageNo: 1,
      //     noOfRecords: NO_OF_RECORDS,
      //     roleCode: "WAREHOUSE",
      //     userType: 71,
      //     isParentId: 0,
      //   })
      // );
      dispatch(
        getBuyer({
          ...searchData,
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
          userType: 71,
          isParentId: 0,
          roleCode: "WAREHOUSE",
        })
      );
    }
  }, [expanded]);

  useEffect(() => {
    axiosMain
      .get(
        `/admin/auctionCenter/getAuctionCentersForRegByUserId/${atob(
          sessionStorage.getItem("argument2")
        )}`
      )
      .then((res) => {
        // debugger;
        setAuctionCenterLists(res.data.responseData || []);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleUnitViewExport = (exportType) => {
    setexportUnitViewType("");
    let id = UnitById && UnitById.wareHouseUnitId;
    let searchData = {
      url: `/admin/wareHouseUserUnitReg/get/getWareHouseUnitById/${id}/${exportType}`,
    };
    setexportUnitViewType(exportType);
    setLoader(true);
    dispatch(getExportDataForView(searchData));
  };

  const getExportDataResponse = useSelector(
    (state) => state.documentReducer.exportData.responseData?.exported_file
  );


  const getExportDataApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataApiCall
  );


  useEffect(() => {
    if (
      getExportDataResponse != null &&
      getExportDataApiCallResponse === true
    ) {
      dispatch(getExportDataForViewApiCall(false));
      if (exportUnitViewType === "excel") {
          Base64ToExcelDownload(
            getExportDataResponse,
            "AuctionCenterDetails.xlsx"
          );
      } else {
          uploadedFileDownload(
            getExportDataResponse,
            "downloaded_document.pdf",
            `data:application/pdf;base64`
          );
      }
    }
  });

  const [formDataUnit, setFormDataUnit] = useState({
    wareHouseUserRegId: null,
    wareHouseUnitCode: null,
    wareHouseUnitName: null,
    isActive: null,
    uploadDocumentRemarks: "",
    auctionCenterId: null,
    gstNo: "",
    address: "",
    shortName: "",
    city: "",
    emailId: "",
    fax: "",
    cinNo: "",
    mobileNo: "",
    phoneNo: "",
    teaBoardRegistrationNo: "",
    auctionCenterId: null,
    auctionCenterName: "",
    wareHouseLicenseNo: "",
    contactPerson: "",
  });

  const UploadedDocumentList = useSelector(
    (res) => res.warehouseUserRegistration.documents?.responseData
  );

  const getAllAuctionCenter = useSelector(
    (state) => state?.auctionCenter?.getAllAuctionCenterAsc?.responseData
  );
  const States = useSelector(
    (state) => state?.state?.getAllStateAsc?.responseData
  );
  const getExportViewDataResponse = useSelector(
    (res) =>
      res.warehouseUserRegistration.userSearch?.data?.responseData
        ?.exported_file
  );
  const SearchUserAll = useSelector(
    (res) => res.warehouseUserRegistration.userSearch?.data
  );
  const UserById = useSelector(
    (res) => res?.warehouseUserRegistration?.userById?.data?.responseData
  );

  const SubUserForId = useSelector(
    (res) => res?.warehouseUserRegistration?.userById?.data?.responseData
  );

  const SearchWareHouseUnit = useSelector(
    (res) => res?.warehouseUserRegistration?.unitsearchData?.data?.responseData
  );

  const SearchWareHouseUnitAll = useSelector(
    (res) => res?.warehouseUserRegistration?.unitsearchData?.data
  );

  const CreateUser = useSelector(
    (res) => res?.warehouseUserRegistration?.createuser
  );

  const CreateUnit = useSelector(
    (res) => res?.warehouseUserRegistration?.createunit?.data
  );

  const UnitById = useSelector(
    (res) => res?.warehouseUserRegistration.unitById?.user.responseData
  );

  const UnitDocument = useSelector(
    (res) => res?.warehouseUserRegistration?.unitdocument?.responseData
  );

  const updateWarehouse = useSelector(
    (res) => res?.warehouseUserRegistration?.updatedData?.responseData
  );

  const getUserDataAll = useSelector((state) => state.createBuyer.getBuyer);

  const Message = useSelector((res) => res.warehouseUserRegistration);

  const [unitDocument, setUnitDocument] = useState([]);

  // const handleAuctionCenter = (event) => {
  //   const {
  //     target: { value, id },
  //   } = event;

  //   // setauctionCenterId(value);
  //   let tempData = typeof value === "string" ? value.split(",") : value;
  //   setOnChangeAuctionCenterId(tempData);

  //   let tempDataNo = [];
  //   getAllAuctionCenter &&
  //     getAllAuctionCenter.map((auctionCenterData, auctioncenterIndex) => {
  //       if (tempData.includes(auctionCenterData.auctionCenterName)) {
  //         tempDataNo.push(auctionCenterData.auctionCenterId.toString());
  //       }
  //     });

  //   setauctionCenterId(tempDataNo);
  //   let tempAuctionCenterData1 = [];
  //   let states = [];
  //   // Get selected auction center
  //   for (let i = 0; i < getAllAuctionCenter.length; i++) {
  //     if (
  //       tempDataNo.includes(getAllAuctionCenter[i].auctionCenterId.toString())
  //     ) {
  //       getAllAuctionCenter[i].gstNo = getAllAuctionCenter[i].gstNo || "";
  //       getAllAuctionCenter[i].address = getAllAuctionCenter[i].address || "";
  //       getAllAuctionCenter[i].statePresent = false;

  //       //if auction Center & selected state id is same
  //       if (tblState != "" && getAllAuctionCenter[i].stateId == tblState) {
  //         getAllAuctionCenter[i].statePresent = true;
  //         states.push(getAllAuctionCenter[i].stateId);
  //       } else if (states && states.length == 0) {
  //         states.push(getAllAuctionCenter[i].stateId);
  //       } else if (states.includes(getAllAuctionCenter[i].stateId)) {
  //         //if currenrt auction Center state id & saved state id is same
  //         getAllAuctionCenter[i].statePresent = true;
  //       } else if (!states.includes(getAllAuctionCenter[i].stateId)) {
  //         states.push(getAllAuctionCenter[i].stateId);
  //       }

  //       tempAuctionCenterData1.push(getAllAuctionCenter[i]);
  //     }
  //   }
  //   setauctioneerGstDtoList(tempAuctionCenterData1);
  // };

  const handleAuctionCenter = (event) => {
    const {
      target: { value },
    } = event;
    console.log(event.target.value, "❤️😜");
    // // let letastData = value.filter((ele, index) => index === value?.length - 1)
    // let tempData = value?.map((eless, index) => typeof eless === "string" ? eless = onChangesAuctionCenterId?.at(index) : eless)
    // // debugger
    // // let tempData = getAllAuctionCenter?.find(ele => ele.auctionCenterId === value);
    // // let tempDatalist = tempData?.map((ele, index) => ele === letastData?.at(0) ? "" : ele)?.filter(ele => ele !== "")

    // debugger
    setOnChangeAuctionCenterId(value);

    let tempDataNo = [];

    // if (auctioneerGstDtoList?.length > 0) {
    //   setauctioneerGstDtoList([...auctioneerGstDtoList, ...getAllAuctionCenter?.filter(ele => ele.auctionCenterId === value?.at(0))])
    // } else {
    if (value?.length >= auctioneerGstDtoList?.length) {
      setauctioneerGstDtoList(
        value
          ?.map(
            (ele) =>
              auctioneerGstDtoList
                ?.map((eles) => eles.auctionCenterName)
                .includes(ele)
                ? auctioneerGstDtoList?.filter(
                    (item) => item.auctionCenterName === ele
                  )
                : getAllAuctionCenter?.filter(
                    (item) => item.auctionCenterName === ele
                  )
            // : getAllAuctionCenter?.filter(
            //   (item) => item.auctionCenterName === ele
            // )
          )
          ?.reduce((curr, next) => curr?.concat(next), [])
      );

      setOLDDataList(
        value
          ?.map(
            (ele) =>
              auctioneerGstDtoList
                ?.map((eles) => eles.auctionCenterName)
                .includes(ele)
                ? auctioneerGstDtoList?.filter(
                    (item) => item.auctionCenterName === ele
                  )
                : getAllAuctionCenter?.filter(
                    (item) => item.auctionCenterName === ele
                  )
            // : getAllAuctionCenter?.filter(
            //   (item) => item.auctionCenterName === ele
            // )
          )
          ?.reduce((curr, next) => curr?.concat(next), [])
      );
    } else {
      if (
        !auctioneerGstDtoList
          ?.map((ele) => ele.auctionCenterName)
          ?.includes(
            value.at(value.length > 0 ? value.length - 1 : value.length)
          )
      ) {
        setauctioneerGstDtoList(
          value
            ?.map(
              (ele) =>
                auctioneerGstDtoList
                  ?.map((eles) => eles.auctionCenterName)
                  .includes(ele)
                  ? auctioneerGstDtoList?.filter(
                      (item) => item.auctionCenterName === ele
                    )
                  : getAllAuctionCenter?.filter(
                      (item) => item.auctionCenterName === ele
                    )
              // : getAllAuctionCenter?.filter(
              //   (item) => item.auctionCenterName === ele
              // )
            )
            ?.reduce((curr, next) => curr?.concat(next), [])
        );

        setOLDDataList(
          value
            ?.map(
              (ele) =>
                auctioneerGstDtoList
                  ?.map((eles) => eles.auctionCenterName)
                  .includes(ele)
                  ? auctioneerGstDtoList?.filter(
                      (item) => item.auctionCenterName === ele
                    )
                  : getAllAuctionCenter?.filter(
                      (item) => item.auctionCenterName === ele
                    )
              // : getAllAuctionCenter?.filter(
              //   (item) => item.auctionCenterName === ele
              // )
            )
            ?.reduce((curr, next) => curr?.concat(next), [])
        );
      }

      setauctionCenterId(value);
    }

    // Log the changes for debugging purposes
    // console.log("Updated Data:", tempAuctionCenterData1);

    // setauctioneerGstDtoList(tempAuctionCenterData1);
  };
  const handlesStateNameChange = (e) => {
    // setstateCode(e.target.options[e.target.selectedIndex].id);
    // settblState(e.target.value);
    const { name, value } = e.target;
    const updatedValue = name === "isActive" ? parseInt(value, 10) : value;
    debugger;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: updatedValue,
    }));
    let tempAuctionCenterData1 = [];
    let states = [];

    // Get selected auction center
    for (let i = 0; i < getAllAuctionCenter.length; i++) {
      if (
        auctionCenterId.includes(
          getAllAuctionCenter[i].auctionCenterId.toString()
        )
      ) {
        getAllAuctionCenter[i].gstNo = "";
        getAllAuctionCenter[i].address = "";
        getAllAuctionCenter[i].statePresent = false;

        //if auction Center & selected state id is same
        if (
          e.target.value != "" &&
          getAllAuctionCenter[i].stateId == e.target.value
        ) {
          getAllAuctionCenter[i].statePresent = true;
          states.push(getAllAuctionCenter[i].stateId);
        } else if (states && states.length == 0) {
          states.push(getAllAuctionCenter[i].stateId);
        } else if (states.includes(getAllAuctionCenter[i].stateId)) {
          //if currenrt auction Center state id & saved state id is same
          getAllAuctionCenter[i].statePresent = true;
        } else if (!states.includes(getAllAuctionCenter[i].stateId)) {
          states.push(getAllAuctionCenter[i].stateId);
        }

        tempAuctionCenterData1.push(getAllAuctionCenter[i]);
      }
    }
    setauctioneerGstDtoList(tempAuctionCenterData1);
  };
  const debouncedApiCall = useCallback(
    debounce((stateId, key, value) => {
      dispatch(gstVerificationRequest(value));
    }, 2000),
    [] // Dependency array to ensure the function is only created once
  );
  const tempAuctionCenterDataChange = (
    key,
    value,
    stateId,
    debouncedApiCall
  ) => {
    let data =
      auctioneerGstDtoList &&
      auctioneerGstDtoList.map((data, index) => {
        if (data.stateId == stateId) {
          data[key] = value;
        }
        return data;
      });
    setauctioneerGstDtoList(data);
    if (key === "gstNo") {
      console.log(stateId, key, value, "stateId, key, value");
      debouncedApiCall(stateId, key, value);
    }
  };

  useEffect(() => {
    let data = StateList?.filter((ele) => ele.stateId == formData?.stateId);
    setStateCode(data?.at(0)?.stateCode);
  }, [formData?.stateId]);
  useEffect(() => {
    let yearObj = {};
    for (let i = 1980; i <= currentYear; i++) {
      yearObj = {};
      yearObj.key = i;
      yearObj.title = i;
      yearObj.value = i;

      optionsForYear.push(yearObj);
    }
    setOptionsForYear(optionsForYear);

    dispatch(
      getAllStateAscAction({
        sortBy: "asc",
        sortColumn: "stateName",
        isActive: 1,
      })
    );
    dispatch(fetchDocumentsRequest());
    dispatch(
      searchUsersRequest({
        pageNo: pageNo,
        noOfRecords: NO_OF_RECORDS,
      })
    );
    dispatch(postWarehouseUserSuccess());
    dispatch(
      getAllAuctionCenterAscAction({
        isActive: 1,
        sortBy: "asc",
        sortColumn: "auctionCenterName",
      })
    );
    dispatch(searchUnitRequest({}));
    dispatch(fetchUnitDocumentsRequest());
  }, []);
  useEffect(() => {
    if (UserById != null && UserById != undefined) {
      let tempAuctionCenterData1 = [];
      let states = [];
      let auctionCenterIdData = [];
      for (let i = 0; i < UserById.wareHouseGstDtoList.length; i++) {
        UserById.wareHouseGstDtoList[i].statePresent = false;
        //if auction Center & selected state id is same
        if (
          UserById.stateId != "" &&
          UserById.wareHouseGstDtoList[i].stateId == UserById.tblState
        ) {
          UserById.wareHouseGstDtoList[i].statePresent = true;
          auctionCenterIdData.push(
            UserById.wareHouseGstDtoList[i].auctionCenterId
          );
          states.push(UserById.wareHouseGstDtoList[i].stateId);
          tempAuctionCenterData1.push(UserById.wareHouseGstDtoList[i]);
        } else if (auctionCenterIdData && auctionCenterIdData.length == 0) {
          auctionCenterIdData.push(
            UserById.wareHouseGstDtoList[i].auctionCenterId
          );
          states.push(UserById.wareHouseGstDtoList[i].stateId);
          tempAuctionCenterData1.push(UserById.wareHouseGstDtoList[i]);
        } else if (states.includes(UserById.wareHouseGstDtoList[i].stateId)) {
          //if currenrt auction Center state id & saved state id is same
          UserById.wareHouseGstDtoList[i].statePresent = true;
          auctionCenterIdData.push(
            UserById.wareHouseGstDtoList[i].auctionCenterId
          );
        } else if (!states.includes(UserById.wareHouseGstDtoList[i].stateId)) {
          states.push(UserById.wareHouseGstDtoList[i].stateId);
          auctionCenterIdData.push(
            UserById.wareHouseGstDtoList[i].auctionCenterId
          );
          tempAuctionCenterData1.push(UserById.wareHouseGstDtoList[i]);
        } else if (
          !auctionCenterIdData.includes(
            UserById.wareHouseGstDtoList[i].auctionCenterIdData
          )
        ) {
          auctionCenterIdData.push(
            UserById.wareHouseGstDtoList[i].auctionCenterId
          );
          // states.push(UserById.wareHouseGstDtoList[i].stateId);
        }
      }
      let tempDataNo = [];
      getAllAuctionCenter &&
        getAllAuctionCenter.map((auctionCenterData, auctioncenterIndex) => {
          if (auctionCenterIdData.includes(auctionCenterData.auctionCenterId)) {
            tempDataNo.push(auctionCenterData.auctionCenterName.toString());
          }
        });
      setauctionCenterId(auctionCenterIdData);
      setOnChangeAuctionCenterId(tempDataNo);
      setIrnEligibility(UserById.irnEligibility);
      setDeclarationCheck(UserById.declarationCheck);
    }
  }, [UserById]);
  useEffect(() => {
    setUploadedDocument(UploadedDocumentList);
    setAuctionCenter(getAllAuctionCenter);
    setStateList(States);
    setUnitSearch(SearchWareHouseUnit);
    setUnitDocument(UnitDocument);
    if (isEdit === true) {
      setFormData(UserById);
      setauctioneerGstDtoList(UserById && UserById.wareHouseGstDtoList);
    }
    if (IsView == true) {
      setviewpdf(true);
      // setDisabled(true)
      setFormData(UserById);
      setField(UserById.auctionCenterId);
      setauctioneerGstDtoList(UserById.wareHouseGstDtoList);
      setEditWarehouseModal(true);
    }
    if (isUnitEdit == true) {
      setFormDataUnit(UnitById);
    }
    if (isUnitAdd == true) {
      // setFormData(SubUserForId === undefined ? [] : SubUserForId);
      // setFormDataUnit(SubUserForId?.wareHouseGstDtoList?.at(0));
      setFormDataUnit({ ...formDataUnit, auctionCenterId: 0 });
      setAuctionCenterList(SubUserForId?.wareHouseGstDtoList);
    }
    if (isViewUnit == true) {
      setFormDataUnit(UnitById);
    }
  }, [
    UploadedDocumentList,
    getAllAuctionCenter,
    States,
    UserById,
    SubUserForId,
    SearchWareHouseUnit,
    UnitById,
    UnitDocument,
  ]);

  const handleAuctionCenterChange = (e) => {
    const { name, value } = e.target;

    let data = auctionCenterList?.filter(
      (ele) => ele.auctionCenterId === parseInt(value)
    );
    setFormDataUnit({
      ...data?.at(0),
      address: "",
      city: "",
      emailId: "",
      fax: "",
      cinNo: "",
      mobileNo: "",
      phoneNo: "",
      teaBoardRegistrationNo: "",
      auctionCenterId: null,
      auctionCenterName: "",
      shortName: "",
      wareHouseLicenseNo: "",
      contactPerson: "",
      auctionCenterId: parseInt(value),
    });

    setFormData(SubUserForId === undefined ? [] : SubUserForId);

    if (parseInt(value) == 0) {
      setFormData({
        uploadDocumentRemarks: "",
        wareHouseName: "",
        wareHouseCode: "",
        roleCode: "WAREHOUSE",
        // wareHouseLicenseNo: "",

        contactPerson: "",
        email: "",
        panNo: "",
        wareHouseGstDtoList: [],
        isActive: 1,
        irnEligibility: 0,
        contactPerson: "",
      });
      setFormDataUnit({
        uploadDocumentRemarks: "",
        wareHouseUnitCode: "",
        wareHouseUnitName: "",
        gstNo: "",
        address: "",
        city: "",
        emailId: "",
        fax: "",
        cinNo: "",
        mobileNo: "",
        phoneNo: "",
        teaBoardRegistrationNo: "",
        auctionCenterId: null,
        auctionCenterName: "",
        shortName: "",
        wareHouseLicenseNo: "",
        auctionCenterId: 0,
        contactPerson: "",
      });
    }
  };

  const handleChangeWareHouseRegDetails = (e) => {
    const { name, value } = e.target;
    setFormDataUnit({ ...formDataUnit, [name]: value });
  };

  console.log(auctionCenterId, "auctionCenterId");

  // const validationRules = [
  //   { field: 'gstNo', message: 'GST No is missing in auctioneer GST details' },
  //   { field: 'auctionCenterName', message: 'Auction Center Name is missing in auctioneer GST details' },
  //   { field: 'localOfficeAddress', message: 'Please enter the Local Office Address' },
  //   { field: 'address', message: 'Please enter the Head Office Address' }, // updated from headOfficeAddress to address
  //   { field: 'city', message: 'Please enter the city' },
  //   { field: 'phoneNo', message: 'Please enter a valid phone number.' },
  //   { field: 'emailId', message: 'Please enter the email ID.' },
  //   { field: 'mobileNo', message: 'Please enter the mobile number' },
  //   { field: 'fax', message: 'Please enter a valid fax number.' },
  //   // { field: 'cinNumber', message: 'Please enter CIN number.' },
  //   { field: 'teaBoardRegNo', message: 'Please enter the Tea Board Registration No.' },
  //   { field: 'taxIdNo', message: 'Please select the Tax Identification No.' },
  //   // { field: 'fssaiNo', message: 'Please enter the FSSAI Number.' },
  // ];

  const validationRules = [
    { field: "gstNo", message: "GST No is missing in auctioneer GST details" },
    {
      field: "auctionCenterName",
      message: "Auction Center Name is missing in auctioneer GST details",
    },
    { field: "address", message: "Please enter the Address" },
    // { field: 'address', message: 'Please enter the Head Office Address' },
    { field: "city", message: "Please enter the city" },
    { field: "phoneNo", message: "Please enter a phone number." },
    { field: "emailId", message: "Please enter the email ID." },
    { field: "mobileNo", message: "Please enter the mobile number" },
    // { field: "fax", message: "Please enter a valid fax number." },
    // { field: 'cinNumber', message: 'Please enter CIN number.' },
    { field: "shortName", message: "Please enter the short name." },
    {
      field: "teaBoardRegistrationNo",
      message: "Please enter the Tea Board Registration No.",
    },
    // { field: "taxIdNo", message: "Please select the Tax Identification No." },
    // {
    //   field: "wareHouseLicenseNo",
    //   message: "Please enter the Warehouse License No.",
    // },
    // { field: 'fssaiNo', message: 'Please enter the FSSAI Number.' },
  ];
  const validateField = (data, fieldName) => {
    const rule = validationRules?.find((rule) => rule.field === fieldName);
    if (!data[fieldName] && rule) {
      return rule.message;
    }
    return "";
  };

  useEffect(() => {
    ClearSearch();
  }, [expanded]);
  // const generateValidationSchema = (columns) => {
  //   return columns
  //     .filter((column) => column.mandatory)
  //     .map((column) => ({
  //       field: column.name,
  //       message: column.validationMessage,
  //     }));
  // };

  const validateFormData = (formData, schema) => {
    for (const rule of schema) {
      if (!formData[rule.field] || formData[rule.field] === "") {
        CustomToast.error(rule.message);
        return false;
      }
    }
    return true;
  };

  const validateWareHouseGstDtoList = (wareHouseGstDtoList, schema) => {
    for (const item of wareHouseGstDtoList) {
      for (const rule of schema) {
        if (!item[rule.field] || item[rule.field] === "") {
          CustomToast.error(rule.message);
          return false;
        }
      }
    }
    return true;
  };

  // Generate the validation schema based on columnsData
  // const validationSchema = generateValidationSchema(columnsData);
  // Validation WarehouseUser
  const validate = () => {
    let isValid = true;

    if (onChangesAuctionCenterId.length === 0) {
      CustomToast.error(
        "Please select an auction center from the dropdown list."
      );
      isValid = false;
      return;
    }

    if (formData.contactPerson == "") {
      CustomToast.error("Please enter the contact person");
      isValid = false;
      return;
    }
    if (formData.email == "") {
      CustomToast.error("Please enter the email Id");
      isValid = false;
      return;
    }

    if (formData.panNo == "") {
      CustomToast.error("Please enter the PANno.");
      isValid = false;
      return;
    }

    if (formData.wareHouseCode == "") {
      CustomToast.error("Please enter the warehouse code");
      isValid = false;
      return;
    }
    if (formData.wareHouseName == "") {
      CustomToast.error("Please enter the warehouse name");
      isValid = false;
      return;
    }

    for (const item of formData.wareHouseGstDtoList) {
      if (!item.gstNo || item.gstNo === "") {
        CustomToast.error("Please enter the CENTER WISE GSTNo");
        isValid = false;
        return;
      }
    }
    for (const item of formData.wareHouseGstDtoList) {
      if (!item.mobileNo || item.mobileNo === "") {
        CustomToast.error("Please enter the Mobile No.");
        isValid = false;
        return;
      }
    }
    // for (const item of formData.wareHouseGstDtoList) {
    //   if (!item.phoneNo || item.phoneNo === "") {
    //     CustomToast.error("Please enter a valid Phone Number");
    //     isValid = false;
    //     return;
    //   }
    // }
    for (const item of formData.wareHouseGstDtoList) {
      if (!item.emailId || item.emailId === "") {
        CustomToast.error("Please enter the Center Wise Email ID");
        isValid = false;
        return;
      }
    }
    for (const item of formData.wareHouseGstDtoList) {
      if (!item.shortName || item.shortName === "") {
        CustomToast.error("Please enter the ShortName");
        isValid = false;
        return;
      }
    }
    for (const item of formData.wareHouseGstDtoList) {
      if (!item.teaBoardRegistrationNo || item.teaBoardRegistrationNo === "") {
        CustomToast.error(
          "Please enter the Center Wise Tea board Rag. No/ Ware House License No."
        );
        isValid = false;
        return;
      }
    }

    //   { field: "gstNo", message: "GST No is missing in auctioneer GST details" },
    //   {
    //     field: "auctionCenterName",
    //     message: "Auction Center Name is missing in auctioneer GST details",
    //   },
    //   { field: "address", message: "Please enter the Address" },
    //   // { field: 'address', message: 'Please enter the Head Office Address' },
    //   { field: "city", message: "Please enter the city" },
    //   { field: "phoneNo", message: "Please enter a phone number." },
    //   { field: "emailId", message: "Please enter the email ID." },
    //   { field: "mobileNo", message: "Please enter the mobile number" },
    //   // { field: "fax", message: "Please enter a valid fax number." },
    //   // { field: 'cinNumber', message: 'Please enter CIN number.' },
    //   { field: "shortName", message: "Please enter the short name." },
    //   {
    //     field: "teaBoardRegistrationNo",
    //     message: "Please enter the Tea Board Registration No.",
    //   },
    //   // { field: "taxIdNo", message: "Please select the Tax Identification No." },
    //   // {
    //   //   field: "wareHouseLicenseNo",
    //   //   message: "Please enter the Warehouse License No.",
    //   // },
    //   // { field: 'fssaiNo', message: 'Please enter the FSSAI Number.' },
    // ];
    //   // if (formData.wareHouseLicenseNo == "") {
    //   //   CustomToast.error("Please enter the warehouse licence no");
    //   //   isValid = false;
    //   //   return;
    //   // }

    if (
      1 == isProfile &&
      (0 == formData.declarationCheck || null == formData.declarationCheck)
    ) {
      CustomToast.error("Please select Terms and Conditions");
      isValid = false;
      return;
    }
    // columnsData.forEach(column => {
    //   if (column.mandatory && !formData[column.name]) {
    //     const message = column.validationMessage || `Please enter ${column.title}.`; // Default validation message
    //     CustomToast.error(message);
    //     isValid = false;
    //   }
    // });
    return isValid;
  };
  const validUnit = () => {
    let isValid = true;
    let errorField = false;

    if (formDataUnit.auctionCenterId == "0") {
      CustomToast.error("Please select an auction center from the list.");
      isValid = false;
      return;
    }
    if (formDataUnit.wareHouseUnitCode == "") {
      CustomToast.error("Please enter the Ware House Unit Code");
      isValid = false;
      return;
    }
    if (formDataUnit.wareHouseUnitName == "") {
      CustomToast.error("Please enter the warehouse unit name");
      isValid = false;
      return;
    }

    auctioneerGstDtoList
      .filter((ele) => onChangesAuctionCenterId.includes(ele.auctionCenterName))
      .forEach((data) => {
        // Check for errors in each row
        const fieldWithError = validationRules?.find(
          (rule) => !data[rule.field]
        );
        if (fieldWithError) {
          errorField = fieldWithError.field;
          isValid = false;
          return; // Exit loop on first error for this row
        }
      });

    // if (!isValid) {
    //   const errorMessage = validateField(auctioneerGstDtoList[0], errorField); // Display error message for the first invalid field
    //   if (errorMessage) {
    //     CustomToast.error(errorMessage);
    //   }
    //   return;
    // }

    if (!isValid) {
      // Display error message for the first invalid field in the first row
      const errorMessage = validateField(
        auctioneerGstDtoList
          .filter((ele) =>
            onChangesAuctionCenterId.includes(ele.auctionCenterName)
          )
          ?.find((data) => !data[errorField]),
        errorField
      );
      if (errorMessage) {
        CustomToast.error(errorMessage);
      }
      return;
    }
    return isValid;
  };

  const resetFormUnit = () => {
    setFormData({
      uploadDocumentRemarks: "",
      wareHouseName: "",
      wareHouseCode: "",
      roleCode: "WAREHOUSE",
      //  wareHouseLicenseNo: "",

      contactPerson: "",
      email: "",
      panNo: "",
      wareHouseGstDtoList: [],
      isActive: 1,
      irnEligibility: 0,
      contactPerson: "",
    });
    setUserId("");
    setFormDataUnit({
      uploadDocumentRemarks: "",
      wareHouseUnitCode: "",
      wareHouseUnitName: "",
      gstNo: "",
      address: "",
      city: "",
      emailId: "",
      fax: "",
      cinNo: "",
      mobileNo: "",
      phoneNo: "",
      teaBoardRegistrationNo: "",
      auctionCenterId: null,
      auctionCenterName: "",
      shortName: "",
      wareHouseLicenseNo: "",
      auctionCenterId: 0,
      contactPerson: "",
      // isActive: null,
      // shortName: "",
      // stateCode: null,
      // stateId: null,
      // stateName: "",
      // taxIdNo: "",
    });
    // setFormData({contactPerson:""})
    setisUnitEdit(false);
    setUploadedFilesUnit([]);
    const inputElement = document.getElementById("UploadWarehouseUnit");
    if (inputElement) {
      inputElement.value = "";
    }
  };
  const resetForm = () => {
    for (let i = 0; i < getAllAuctionCenter.length; i++) {
      getAllAuctionCenter[i].gstNo = "";
      getAllAuctionCenter[i].address = "";
    }
    setDisabled(false);
    setUserId("");
    setFormData({
      uploadDocumentRemarks: "",
      wareHouseUserRegId: 0,
      wareHouseName: "",
      wareHouseCode: "",
      wareHouseLicenseNo: "",
      address: "",
      city: "",
      contactPerson: "",
      email: "",
      entityCode: "",
      phoneNo: "",
      mobileNo: "",
      fax: "",
      cinNo: "",
      auctionCenterId: [],
      shortName: "",
      stateId: 0,
      panNo: "",
      gstNo: "",
      taxIdentityNo: "",
      teaBoardRegistrationNo: "",
      isActive: 1,
      downloadDto: [],
    });
    setIsedit(false);
    setauctionCenterId("");
    setauctioneerGstDtoList([]);
    setStateCode("");
    setOnChangeAuctionCenterId([]);
    setUploadedDocuments([]);
    setUploadedFiles([]);
    setIrnEligibility(0);
    setDeclarationCheck(0);
    const inputElement = document.getElementById("UploadWarehouseUser");
    if (inputElement) {
      inputElement.value = "";
    }
  };

  useEffect(() => {
    // if(expandedSub==="pa")
    resetFormUnit();
  }, [expandedSub]);
  const handleFileUpload = (files) => {
    const newFiles = files?.map((file) => ({
      documentContent: file.documentContent,
      documentName: file.documentName,
      documentSize: file.documentSize,
    }));
    setUploadedDocuments(newFiles);
  };
  const handleFileUploadForUnit = (files) => {
    const newFiles = files?.map((file) => ({
      documentContent: file.documentContent,
      documentName: file.documentName,
      documentSize: file.documentSize,
    }));
    setUploadedDocumentsForUnit(newFiles);
  };
  const debouncedGstNoCApiCall = debounce((value) => {
    // Call your API here with the updated value for GST NoC
    dispatch(gstVerificationRequest(value));
  }, 1000); // Adjust the debounce delay as needed (here, it's 1000 milliseconds or 1 second)

  const handleChange = (event) => {
    const { name, value } = event.target;
    const updatedValue = name === "isActive" ? parseInt(value, 10) : value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: updatedValue,
    }));
  };

  const handleInputChange = (event) => {
    handleChange(event); // Update local state immediately

    const { name, value } = event.target;
    if (name === "gstNo") {
      // Clear previous timeout
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      // If the new value is empty, don't trigger the API call
      if (value.trim() === "") {
        return;
      }
      // Set timeout to call the debounced function
      const timeout = setTimeout(() => {
        // Call the debounced function
        debouncedGstNoCApiCall(value);
      }, 1000);
      // Update state with the timeout ID
      setTypingTimeout(timeout);
    }
  };
  // File Select for Unit
  const handleChangeForUnit = (e) => {
    const { name, value } = e.target;
    const updatedValue = name === "isActive" ? parseInt(value, 10) : value;
    setFormDataUnit((prevFormData) => ({
      ...prevFormData,
      [name]: updatedValue,
    }));
  };
  const handleChangeAuctionCenter = (event) => {
    const {
      target: { value, id },
    } = event;
    setField(typeof value === "string" ? value.split(",") : value);
  };

  const Status = [
    { status: "Active", id: 1 },
    { status: "Inactive", id: 0 },
    { status: "Suspend", id: 2 },
  ];
  //  Warehouse Form Submit
  let loading1 = useSelector(
    (state) => state.warehouseUserRegistration.loading
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    formData.auctionCenterId = field;
    formData.downloadDto = uploadedDocuments;
    formData.wareHouseGstDtoList = auctioneerGstDtoList.filter((ele) =>
      onChangesAuctionCenterId.includes(ele.auctionCenterName)
    );
    formData.roleCode = "WAREHOUSE";
    if (validate()) {
      setIsSubmitting(true);
      setTimeout(() => {
        if (isEdit == true) {
          formData.wareHouseUserRegId = userId;
          if (validate() && isEdit == true) {
            formData.irnEligibility = irnEligibility;
            formData.declarationCheck = declarationCheck;
            setLoader(true);
            dispatch(updateWarehouseUserRequest(formData));
          }
        } else {
          dispatch(postWarehouseUserRequest(formData));
        }
        setIsSubmitting(false);
      }, 500);
    } else {
      return false;
    }
  };
  // Unit Form Submit
  const handleSubmitForUnit = (e) => {
    e.preventDefault();
    formDataUnit.downloadDto = uploadedDocumentsForUnit;
    formDataUnit.wareHouseUserRegId = IdForSubUser;
    formDataUnit.roleCode = "WAREHOUSEUNIT";
    if (validUnit() && isUnitEdit != true) {
      setLoader(true);
      dispatch(createWarehouseUnitRequest(formDataUnit));
    }
  };
  const handleViewExport = (exportType) => {
    setexportViewType("")
    dispatch(
      searchUsersRequest({
        ...searchData,
        pageNo: pageNo,
        wareHouseCode: searchData.userCode,
        wareHouseName: searchData.userName,
        // noOfRecords: NO_OF_RECORDS,
        isExport: 1,
        roleCode: "WAREHOUSE",
        exportType: exportType,
      })
    );
    setexportViewType(exportType);
    setLoader(true);
  };

  const tes = useSelector(
    (state) => state.documentReducer.exportViewData.responseData?.exported_file
  );

  const getExportDataViewApiCallResponse = useSelector(
    (state) => state.documentReducer.exportDataForViewApiCall
  );

  useEffect(() => {
    if (
      getExportViewDataResponse != null &&
      true == getExportDataViewApiCallResponse
    ) {
      dispatch(getExportDataForViewApiCall(false));
      if ("excel" == exportViewType) {
        Base64ToExcelDownload(
          getExportViewDataResponse,
          "WarehouseDetail.xlsx"
        );
      } else if ("pdf" == exportViewType) {
        uploadedFileDownload(
          getExportViewDataResponse,
          "WarehouseDetail.pdf",
          `data:application/pdf;base64`
        );
      }
    }
  },[getExportViewDataResponse]);

  const ApiDataWare = useSelector(
    (state) => state?.warehouseUserRegistration?.WarehouseLoader
  );

  useEffect(() => {
    if (true == ApiDataWare) {
      setTimeout(() => {
        setLoader(false);
        pageNo = pageNo;
      }, 1000);
    }
  });

  let createdisable = useSelector(
    (state) => state.warehouseUserRegistration.createWarehouseDisable
  );

  useEffect(() => {
    if (true == createdisable) {
      setIsSubmitting(false);
    }
  });
  let createData = useSelector(
    (state) => state.warehouseUserRegistration.createEditApiStatusWarehouse
  );

  useEffect(() => {
    if (expanded === "panel2") {
      dispatch(
        getBuyer({
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
          userType: 71,
          isParentId: 0,
          roleCode: "WAREHOUSE",
        })
      );
    }
  }, []);

  useEffect(() => {
    if (true == createData && createdisable) {
      dispatch(createEditApiStatusWarehouse(false));
      dispatch(createWarehouseDisable(false));
      setExpanded("panel2");
      setExpandedSub("panel2");
      dispatch(
        getBuyer({
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
          userType: 71,
          isParentId: 0,
          roleCode: "WAREHOUSE",
        })
      );

      setIsSubmitting(false);
      dispatch(searchUnitRequest({ wareHouseUserRegId: IdForSubUser }));
      dispatch(
        searchUsersRequest({
          ...searchData,
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
        })
      );
      setEditWarehouseUnitModal(false);
      setViewWarehouseUnitModal(false);
      setEditWarehouseModal(false);
      setViewWarehouseModal(false);
      if (isProfile == 1) {
        dispatch(closemodel(closestatusjpgp + 1));
      }
    } else if (true == createData) {
      dispatch(createEditApiStatusWarehouse(false));
      handleCloseEditWarehouseModal();
      setExpanded("panel2");
      setExpandedSub("panel2");
      resetFormUnit();
      setIsSubmitting(false);
      dispatch(
        getBuyer({
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
          userType: 71,
          isParentId: 0,
          roleCode: "WAREHOUSE",
        })
      );

      dispatch(searchUnitRequest({ wareHouseUserRegId: IdForSubUser }));
      dispatch(
        searchUsersRequest({
          ...searchData,
          pageNo: pageNo,
          noOfRecords: NO_OF_RECORDS,
        })
      );
      setEditWarehouseUnitModal(false);
      setViewWarehouseUnitModal(false);
      setEditWarehouseModal(false);
      setViewWarehouseModal(false);
      if (isProfile == 1) {
        dispatch(closemodel(closestatusjpgp + 1));
      }
    }
  });

  const SaveUpdatedForUnit = () => {
    if (validUnit() && isUnitEdit == true) {
      const updatedData = { ...formDataUnit, roleCode: "WAREHOUSEUNIT" };
      setLoader(true);
      dispatch(updateWarehouseUnitRequest(updatedData));
      ClearSearch();
    }
  };

  const handleFormDataUnitChange = (e) => {
    const { name, value } = e.target;
    setFormDataUnit((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const closestatusjpgp = useSelector((state) => state.createBuyer.closemodel);
  useEffect(() => {
    if (isProfile == 1) {
      EditUserData(atob(sessionStorage.getItem("argument2")), 0);
    }
  }, []);

  // Edit Warehouse
  const EditUserData = (id, isManage) => {
    setUserId(id);
    setIsView(false);
    setIsedit(true);
    setDisabled(false);
    // setExpanded("panel1");
    setEditWarehouseModal(true);
    let data = {
      id: id,
      isManage: isManage,
    };
    dispatch(getUserRequest(data));
  };

  // Edit Unit
  const EditUnit = (unitData) => {
    resetFormUnit();
    setIsView(false);
    setViewUnit(false);
    setwarehouseDisabled(false);
    setisUnitAdd(false);
    setisUnitEdit(true);
    dispatch(getUnitRequest(unitData));
    // setExpandedSub("panel1");
    setEditWarehouseUnitModal(true);
  };

  const [IsView, setIsView] = useState([]);
  // View Warehouse Read Only
  const ViewUserData = (id, isManage) => {
    setUserId(id);
    setIsedit(false);
    setDisabled(true);
    setIsView(true);
    // setExpanded("panel1");
    // setViewWarehouseModal(true);
    let data = {
      id: id,
      isManage: isManage,
    };
    dispatch(getUserRequest(data));
  };
  // View Unit Read Only
  const ViewUniWareHouse = (unitData) => {
    setViewUnit(true);
    resetFormUnit();
    setisUnitAdd(false);
    setisUnitEdit(false);
    dispatch(getUnitRequest(unitData));
    setwarehouseDisabled(true);
    // setExpandedSub("panel1");
    setViewWarehouseUnitModal(true);
  };
  const [documentMode, setDocumentmode] = useState("");
  const handleDownloadClick = (uploadDocumentConfId, type) => {
    setDocumentmode(type);
    dispatch(getDocumentByIdAction(uploadDocumentConfId));
  };
  const getUploadedIdData = useSelector(
    (state) => state.documentReducer.documentData.responseData
  );
  useEffect(() => {
    if (
      getUploadedIdData &&
      getUploadedIdData.documentContent &&
      "download" == documentMode
    ) {
      dispatch(getDocumentByIdActionSuccess(""));
      uploadedFileDownload(
        getUploadedIdData.documentContent,
        getUploadedIdData.documentName,
        "data:application/pdf;base64"
      );
    }
    if (
      getUploadedIdData &&
      getUploadedIdData.documentContent &&
      "preview" == documentMode
    ) {
      dispatch(getDocumentByIdActionSuccess(""));
      setPreviewModal(true);
      setPreviewDocumentContent(getUploadedIdData.documentContent);
    }
  }, [getUploadedIdData]);

  const handleDownloadPDF = () => {
    if (getUploadedIdData && getUploadedIdData.documentContent) {
      uploadedFileDownload(
        getUploadedIdData.documentContent,
        getUploadedIdData.documentName,
        "data:application/pdf;base64"
      );
    }
  };

  // Get Search Value Warehouse
  const handleSearchWarehouse = (e) => {
    const { name, value } = e.target;
    setSearchData({ ...searchData, [name]: value });
  };

  const handleViewMore = () => {
    pageNo = pageNo + 1;
    dispatch(
      getBuyer({
        ...searchData,
        pageNo: pageNo,
        noOfRecords: NO_OF_RECORDS,
        userType: 71,
        isParentId: 0,
        roleCode: "WAREHOUSE",
      })
    );
  };
  // Search Warehouse
  const [loader, setLoader] = useState(false);

  const fetchData = () => {
    dispatch(
      getBuyer({
        ...searchData,
        pageNo: pageNo,
        noOfRecords: NO_OF_RECORDS,
        userType: 71,
        isParentId: 0,
        roleCode: "WAREHOUSE",
      })
    );
  };
  const handleSearch = (e) => {
    // e.preventDefault();
    setRegUsers([]);
    pageNo = 1;
    setLoader(true);
    // dispatch(
    //   searchUsersRequest({
    //     ...searchData,
    //     pageNo: 1,
    //     noOfRecords: NO_OF_RECORDS,
    //     roleCode: "WAREHOUSE",
    //     userType: 71,
    //     isParentId: 0,
    //   })
    // );
    fetchData();
  };
  // const [rows, setRows] = useState([]);
  // useEffect(() => {
  //   const newRows = SearchUser || [];
  //   setRegUsers((prevRows) => {
  //     const currentRows = Array.isArray(prevRows) ? prevRows : [];
  //     return [...currentRows, ...newRows];
  //   });
  // }, [SearchUser]);
  const getUserData = useSelector(
    (state) => state.createBuyer.getBuyer.responseData
  );

  console.log(getUserData, "😜😜😜1212");

  useEffect(() => {
    console.log(getUserData, "😜😜😜");
    const newRows = getUserData || [];
    setRegUsers((prevRows) => {
      const currentRows = Array.isArray(prevRows) ? [...prevRows] : [];

      newRows.forEach((newRow) => {
        const index = currentRows.findIndex(
          (row) => row.userId === newRow.userId
        );

        if (index !== -1) {
          currentRows[index] = newRow;
        } else {
          currentRows.push(newRow);
        }
      });

      return currentRows;
    });
  }, [getUserData]);
  // Clear Search Warehouse
  const ClearSearch = () => {
    setRegUsers([]);
    pageNo = 1;
    dispatch(
      getBuyer({
        pageNo: pageNo,
        noOfRecords: NO_OF_RECORDS,
        userType: 71,
        isParentId: 0,
        roleCode: "WAREHOUSE",
      })
    );
    searchData.userName = "";
    searchData.userCode = "";
    searchData.contactPerson = "";
    searchData.teaBoardRegistrationCertificate = "";
    searchData.email = "";
    searchData.gstNo = "";
    searchData.panNo = "";
    searchData.auctioncenterIdAbc = "";
    searchData.isActive = "";
  };

  // Get Search Value Unit
  const handleSearchUnit = (e) => {
    const { name, value } = e.target;
    setUnitSearchData({ ...unitSearchData, [name]: value });
  };
  // Search Value Unit
  const handleUnitSearchSubmit = (e) => {
    e.preventDefault();
    setUnitSearchData({
      ...unitSearchData,
      ["wareHouseUserRegId"]: IdForSubUser,
    });
    setRegUsers([]);
    pageNo = 1;
    setLoader(true);
    dispatch(searchUnitRequest(unitSearchData));
  };
  // Clear Search Unit
  const ClearUnitSearch = () => {
    // formDataUnit.wareHouseUserRegId = IdForSubUser;
    dispatch(searchUnitRequest({ wareHouseUserRegId: IdForSubUser }));
    setUserId("");
    setUnitSearchData({
      ...unitSearchData, // Preserve existing properties
      wareHouseUnitCode: "",
      wareHouseUnitName: "",
      wareHouseUserRegId: IdForSubUser,
    });
  };
  const [IdForSubUser, setIdForSubUser] = useState("");
  // Add Warehouse Unit
  const AddNewSubUser = (id) => {
    setIsView(false);
    setIsedit(false);
    resetFormUnit();
    setisUnitAdd(true);
    setIdForSubUser(id);
    setisUnitEdit(false);
    let data = {
      id: id,
      isManage: 1,
    };
    dispatch(getUserRequest(data));
    setExpandedSub("panel1");
    setIsSubmitting(false);
    dispatch(searchUnitRequest({ wareHouseUserRegId: id }));
    setShowmodal(true);
  };

  const CloseUnitModal = () => {
    setShowmodal(false);
    resetForm();
    resetFormUnit();
    setIdForSubUser("");
    setUserId("");
  };

  const ShowWarehouseHistory = (id) => {
    const tableName = "tbl_wareHouseUserReg";
    const moduleName = "WareHouseUserReg";
    dispatch(getHistoryByIdAction(tableName, moduleName, id));
    setShowmodalWarehouseHistory(true);
  };

  const ShowUnitHistory = (id) => {
    const tableName = "tbl_wareHouseUserUnit";
    const moduleName = "WareHouseUserUnit";
    dispatch(getHistoryByIdAction(tableName, moduleName, id));
    setShowmodalWarehouseUnitHistory(true);
  };

  const hideWarehouseHistory = () => {
    setShowmodalWarehouseHistory(false);
  };
  const hideUnitHistory = (id) => {
    setShowmodalWarehouseUnitHistory(false);
  };

  const handleResetPassClick = (id) => {
    dispatch(ResetPassWordByAdminAction(id));
  };

  const handleCloseViewWarehouseModal = () => {
    setViewWarehouseModal(false);
  };

  const handleCloseEditWarehouseModal = () => {
    if (isProfile == 1) {
      dispatch(closemodel(closestatusjpgp + 1));
    }
    resetForm();
    setEditWarehouseModal(false);
  };

  const handleCloseViewWarehouseUnitModal = () => {
    setViewWarehouseUnitModal(false);
  };

  const handleCloseEditWarehouseUnitModal = () => {
    setEditWarehouseUnitModal(false);
  };
  // const [onChangesAuctionCenterId, setOnChangesAuctionCenterId] = useState([]);

  //   useEffect(() => {
  //     if (responseData && responseData.wareHouseGstDtoList) {
  //         const selectedAuctionCenterIds = responseData.wareHouseGstDtoList.map(item => item.auctionCenterId);
  //         setOnChangesAuctionCenterId(selectedAuctionCenterIds);
  //     }
  // }, [responseData]);
  // useEffect(() => {
  //   if (UserById && UserById.wareHouseGstDtoList) {
  //       const selectedAuctionCenterIds = UserById.wareHouseGstDtoList.map(item => item.auctionCenterId);

  //       let tempDataNo = [];
  //       getAllAuctionCenter &&
  //         getAllAuctionCenter.map((auctionCenterData, auctioncenterIndex) => {
  //           if (selectedAuctionCenterIds.includes(auctionCenterData.auctionCenterId)) {
  //             tempDataNo.push(auctionCenterData.auctionCenterName.toString());
  //           }
  //         });
  //         console.log("line 1044",tempDataNo)

  //       setOnChangeAuctionCenterId(tempDataNo);
  //   }
  // }, [UserById]);

  useEffect(() => {
    setFormData({
      uploadDocumentRemarks: "",
      wareHouseUserRegId: 0,
      wareHouseName: "",
      wareHouseCode: "",
      wareHouseLicenseNo: "",
      address: "",
      city: "",
      contactPerson: "",
      email: "",
      entityCode: "",
      phoneNo: "",
      mobileNo: "",
      fax: "",
      auctionCenterId: [],
      shortName: "",
      stateId: 0,
      panNo: "",
      gstNo: "",
      taxIdentityNo: "",
      teaBoardRegistrationNo: "",
      isActive: 1,
      downloadDto: [],
    });
    // setIsedit(false);
    setauctionCenterId("");
    setauctioneerGstDtoList([]);
    setStateCode("");
    setOnChangeAuctionCenterId([]);
    setUploadedDocuments([]);
    setUploadedFiles([]);
    setIrnEligibility(0);
    setDeclarationCheck(0);
  }, []);
  const handleClosePreviewModal = () => {
    dispatch(getDocumentByIdActionSuccess(""));
    setDocumentmode("");
    setPreviewModal(false);
    setPreviewDocumentContent("");
  };
  return (
    <>
      {/* Create */}
      {modalRight
        ?.map((ele) => ele.rightIds)
        ?.at(0)
        ?.includes("1") && (
        <Accordion
          expanded={expanded === "panel1"}
          className={`${expanded === "panel1" ? "active" : ""}`}
          onChange={handleChangeExpand("panel1")}
          TransitionProps={{ unmountOnExit: true }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Create Warehouse User Registrations </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <form onSubmit={handleSubmit}>
                <div className="row align-items-center">
                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Address</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        value={formData?.address}
                        onChange={handleChange}
                        maxLength={500}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Auction Center</label>
                      <label className="errorLabel"> * </label>

                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={onChangesAuctionCenterId}
                        onChange={handleAuctionCenter}
                        input={<OutlinedInput label="Tag" />}
                        renderValue={(selected) => selected.join(", ")}
                        className="w-100"
                      >
                        {getAllAuctionCenter?.map((AuctionCenter) => (
                          <MenuItem
                            key={AuctionCenter?.auctionCenterId}
                            value={AuctionCenter?.auctionCenterName} // Change to auctionCenterId
                          >
                            <Checkbox
                              checked={
                                onChangesAuctionCenterId.indexOf(
                                  AuctionCenter?.auctionCenterName
                                ) > -1
                              }
                            />
                            <ListItemText
                              primary={AuctionCenter?.auctionCenterName}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                      {auctionCenterIdError && (
                        <p className="errorLabel">{auctionCenterIdError}</p>
                      )}
                    </div>
                  </div>

                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>City</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="city"
                        value={formData?.city}
                        onChange={handleChange}
                        maxLength={50}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Contact Person</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="contactPerson"
                        value={formData && formData.contactPerson}
                        onChange={handleChange}
                        maxLength={100}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Primary Email ID</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="email"
                        value={formData?.email}
                        onChange={handleChange}
                        maxLength={50}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  {/* {isEdit == true ? (
                    <>
                      <div className="col-md-2">
                        <div className="FomrGroup">
                          <label>Entity Code</label>
                          <input
                            type="text"
                            className="form-control"
                            name="entityCode"
                            value={formData?.entityCode}
                            onChange={handleChange}
                            disabled
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )} */}
                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Fax</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="fax"
                        value={formData?.fax}
                        onChange={handleChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>GST No</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="gstNo"
                        value={formData?.gstNo}
                        onChange={handleInputChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Mobile No</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="mobileNo"
                        value={formData?.mobileNo}
                        onChange={handleChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>PAN No</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="panNo"
                        value={formData?.panNo}
                        onChange={handleChange}
                        maxLength={10}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Phone </label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="phoneNo"
                        value={formData?.phoneNo}
                        onChange={handleChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Short Name</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="shortName"
                        value={formData?.shortName}
                        onChange={handleChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>State Name</label>
                      <label className="errorLabel"> * </label>
                      <select
                        name="stateId"
                        value={formData?.stateId}
                        onChange={handlesStateNameChange}
                        className="form-control select-form"
                        maxLength={500}
                        disabled={disabled}
                      >
                        <option>Select State</option>
                        {StateList?.map((StateList, index) => (
                          <option key={index} value={StateList.stateId}>
                            {StateList.stateName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>State Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="StateCode"
                        value={StateCode}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Tax Id No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="taxIdentityNo"
                        value={formData?.taxIdentityNo}
                        onChange={handleChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Teaboard Reg No</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="teaBoardRegistrationNo"
                        value={formData?.teaBoardRegistrationNo}
                        onChange={handleChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Ware House Code </label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="wareHouseCode"
                        value={formData?.wareHouseCode}
                        onChange={handleChange}
                        maxLength={50}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Ware House Name</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="wareHouseName"
                        value={formData?.wareHouseName}
                        onChange={handleChange}
                        maxLength={50}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Ware House License No</label>
                      <label className="errorLabel"> * </label>
                      <input
                        type="text"
                        className="form-control"
                        name="wareHouseLicenseNo"
                        value={formData?.wareHouseLicenseNo}
                        onChange={handleChange}
                        maxLength={15}
                        disabled={disabled}
                      />
                    </div>
                  </div> */}
                  {isEdit == true && (
                    <div className="col-auto">
                      <div className="FomrGroup">
                        <label>Status</label>

                        <div className="d-flex CheckboxGroup">
                          <>
                            <div className="d-flex">
                              <div class="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={1}
                                  onChange={handleChange}
                                  checked={formData?.isActive === 1}
                                />
                                <label className="form-check-label">
                                  Active
                                </label>
                              </div>
                              &nbsp;&nbsp;
                              <div class="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={2}
                                  onChange={handleChange}
                                  checked={formData?.isActive === 2}
                                />
                                <label className="form-check-label">
                                  Inactive
                                </label>
                              </div>
                              &nbsp;&nbsp;
                              <div class="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={3}
                                  onChange={handleChange}
                                  checked={formData?.isActive === 3}
                                />
                                <label className="form-check-label">
                                  Suspend
                                </label>
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  )}

                  <UserTable
                    columns={columnsData}
                    rows={auctioneerGstDtoList}
                    setRows={setauctioneerGstDtoList}
                    OLDDataList={OLDDataList}
                    setOLDDataList={setOLDDataList}
                    onChangesAuctionCenterId={onChangesAuctionCenterId}
                    disabled={disabled}
                  />

                  {/* <div className="col-12">
                    {auctioneerGstDtoList?.length > 0 ? (
                      <>
                          <div className="row">
                       <div className="col-6">
                          {auctioneerGstDtoList &&
                            auctioneerGstDtoList.map((data, index) => (
                              <>
                                {!data.statePresent ? (
                                  <div className="col-12">
                                  <div className="GSTBox">
                                  <div className="row mt-2">
                                    <div className="col-md-3">
                                      <div className="FormGroup">
                                        <label>Sr No.</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={index + 1}
                                          disabled={true}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-3">
                                      <div className="FormGroup">
                                        <label>State</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data?.stateName}
                                          disabled={true}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-3">
                                      <div className="FormGroup">
                                        <label>GSTNo</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data?.gstNo}
                                          onChange={(e) =>
                                            tempAuctionCenterDataChange(
                                              "gstNo",
                                              e.target.value,
                                              data.stateId,
                                              debouncedApiCall
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="FormGroup">
                                        <label> Address</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={data?.address}
                                          onChange={(e) =>
                                            tempAuctionCenterDataChange(
                                              "address",
                                              e.target.value,
                                              data.stateId
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            ))}
                        </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div> */}
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <UploadMultipleDocuments
                      onFileSelect={handleFileUpload}
                      uploadedFiles={uploadedFiles}
                      setUploadedFiles={setUploadedFiles}
                      uploadDocumentError={uploadDocumentError}
                      inputId="UploadWarehouseUser"
                    />
                    <div className="form-group my-3">
                      <label>Remarks</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.uploadDocumentRemarks}
                        onChange={handleChange}
                        name="uploadDocumentRemarks"
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-auto">
                    <div className="BtnGroup">
                      <button
                        className={"SubmitBtn"}
                        disabled={isSubmitting || loading1}
                      >
                        {loading1 ? "Loading..." : "Submit"}
                      </button>
                      <button
                        className="SubmitBtn"
                        type="button"
                        onClick={() => resetForm()}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}

      {/* Edit */}

      {editWarehouseModal ? (
        <Modals
          title={
            disabled
              ? "View warehouse user registration"
              : "Edit " + "Warehouse User Registration"
          }
          show={editWarehouseModal}
          handleClose={handleCloseEditWarehouseModal}
          size="xl"
          centered
        >
          <form onSubmit={handleSubmit}>
            <div className="row align-items-center">
              {/* <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Address</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData?.address}
                    onChange={handleChange}
                    maxLength={500}
                    disabled={disabled}
                  />
                </div>
              </div> */}
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Auction Center</label>
                  <label className="errorLabel"> * </label>

                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={onChangesAuctionCenterId}
                    onChange={handleAuctionCenter}
                    input={<OutlinedInput label="Tag" />}
                    renderValue={(selected) => selected.join(", ")}
                    className="w-100"
                    disabled={disabled}
                  >
                    {console.log(
                      getAllAuctionCenter,
                      onChangesAuctionCenterId,
                      "getAllAuctionCentergetAllAuctionCenter"
                    )}
                    {getAllAuctionCenter?.map((AuctionCenter) => (
                      <MenuItem
                        key={AuctionCenter?.auctionCenterId}
                        value={AuctionCenter?.auctionCenterName} // Change to auctionCenterId
                      >
                        <Checkbox
                          checked={
                            onChangesAuctionCenterId.indexOf(
                              AuctionCenter?.auctionCenterName
                            ) > -1
                          }
                        />
                        <ListItemText
                          primary={AuctionCenter?.auctionCenterName}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                  {auctionCenterIdError && (
                    <p className="errorLabel">{auctionCenterIdError}</p>
                  )}
                </div>
              </div>

              {/* <div className="col-md-2">
                <div className="FomrGroup">
                  <label>City</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={formData?.city}
                    onChange={handleChange}
                    maxLength={50}
                    disabled={disabled}
                  />
                </div>
              </div> */}
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Contact Person</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="contactPerson"
                    value={formData && formData.contactPerson}
                    onChange={handleChange}
                    maxLength={100}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Primary Email ID</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                    maxLength={50}
                    disabled={disabled}
                  />
                </div>
              </div>
              {/* {isEdit == true ? (
                <>
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Entity Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="entityCode"
                        value={formData?.entityCode}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )} */}
              {/* <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Fax</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="fax"
                    value={formData?.fax}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>GST No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="gstNo"
                    value={formData?.gstNo}
                    onChange={handleInputChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Mobile No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobileNo"
                    value={formData?.mobileNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div> */}
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>PAN No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="panNo"
                    value={formData?.panNo}
                    onChange={handleChange}
                    maxLength={10}
                    disabled={disabled}
                  />
                </div>
              </div>
              {/* <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Phone </label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="phoneNo"
                    value={formData?.phoneNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Short Name</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="shortName"
                    value={formData?.shortName}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>State Name</label>
                  <label className="errorLabel"> * </label>
                  <select
                    name="stateId"
                    value={formData?.stateId}
                    onChange={handleChange}
                    className="form-control select-form"
                    maxLength={500}
                    disabled={disabled}
                  >
                    <option>Select State</option>
                    {StateList?.map((StateList, index) => (
                      <option key={index} value={StateList.stateId}>
                        {StateList.stateName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>State Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="StateCode"
                    value={StateCode}
                    onChange={handleChange}
                    disabled
                  />
                </div>
              </div>

              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Tax Id No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="taxIdentityNo"
                    value={formData?.taxIdentityNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>

              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Teaboard Reg No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="teaBoardRegistrationNo"
                    value={formData?.teaBoardRegistrationNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div> */}
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Ware House Code</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="wareHouseCode"
                    value={formData?.wareHouseCode}
                    onChange={handleChange}
                    maxLength={50}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Ware House Name</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="wareHouseName"
                    value={formData?.wareHouseName}
                    onChange={handleChange}
                    maxLength={50}
                    disabled={disabled}
                  />
                </div>
              </div>
              {/* <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Ware House License No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="wareHouseLicenseNo"
                    value={formData?.wareHouseLicenseNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div> */}

              <div className="col-md-4">
                <div className="FormGroup">
                  <label>IRN Eligibility (Turnover Exceeds 5 CREdit)</label>
                  <select
                    className="form-control select-form"
                    value={irnEligibility}
                    onChange={(e) => setIrnEligibility(e.target.value)}
                    disabled={1 == isProfile ? false : true}
                  >
                    <option value={1}>Yes</option>
                    <option value={0}>No</option>
                  </select>
                </div>
              </div>

              {isEdit == true && 1 !== isProfile && (
                <div className="col-auto">
                  <div className="FomrGroup">
                    <label>Status</label>

                    <div className="d-flex CheckboxGroup">
                      <>
                        <div className="d-flex">
                          <div class="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isActive"
                              value={1}
                              onChange={handleChange}
                              checked={formData?.isActive === 1}
                            />
                            <label className="form-check-label">Active</label>
                          </div>
                          &nbsp;&nbsp;
                          <div class="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isActive"
                              value={2}
                              onChange={handleChange}
                              checked={formData?.isActive === 2}
                            />
                            <label className="form-check-label">Inactive</label>
                          </div>
                          &nbsp;&nbsp;
                          <div class="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isActive"
                              value={3}
                              onChange={handleChange}
                              checked={formData?.isActive === 3}
                            />
                            <label className="form-check-label">Suspend</label>
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              )}
              {/* <div className="col-6">
                {auctioneerGstDtoList?.length > 0 ? (
                  <>
                    <div className="row">
                      <div className="col-12">
                        {auctioneerGstDtoList &&
                          auctioneerGstDtoList.map((data, index) => (
                            <>
                              {!data.statePresent ? (
                                <div className="col-12">
                                  <div className="GSTBox">
                                    <div className="row mt-2">
                                      <div className="col-md-3">
                                        <div className="FormGroup">
                                          <label>Sr No.</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={index + 1}
                                            disabled={true}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <div className="FormGroup">
                                          <label>State</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={data?.stateName}
                                            disabled={true}
                                          />
                                        </div>
                                      </div>

                                      <div className="col-md-3">
                                        <div className="FormGroup">
                                          <label>GSTNo</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={data?.gstNo}
                                            onChange={(e) =>
                                              tempAuctionCenterDataChange(
                                                "gstNo",
                                                e.target.value,
                                                data.stateId,
                                                debouncedApiCall
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="FormGroup">
                                          <label> Address</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={data?.address}
                                            onChange={(e) =>
                                              tempAuctionCenterDataChange(
                                                "address",
                                                e.target.value,
                                                data.stateId
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div> */}
            </div>
            <div className="row">
              {/* {auctioneerGstDtoList && auctioneerGstDtoList?.length > 0 ? ( */}
              <div className="col-12">
                <UserTable
                  columns={columnsData}
                  rows={auctioneerGstDtoList}
                  setRows={setauctioneerGstDtoList}
                  OLDDataList={OLDDataList}
                  setOLDDataList={setOLDDataList}
                  onChangesAuctionCenterId={onChangesAuctionCenterId}
                  disabled={disabled}
                />
              </div>

              {/* ) : (
                        ""
                      )} */}
            </div>

            {viewpdf && (
              <div className="col-md-12">
                <div className="BtnGroup">
                  {modalRight
                    ?.map((ele) => ele.rightIds)
                    ?.at(0)
                    ?.includes("11") && (
                    <button
                      type="button"
                      class="SubmitBtn"
                      onClick={() => handleViewExport("excel")}
                    >
                      <i class="fa fa-file-excel"></i>
                    </button>
                  )}
                  {modalRight
                    ?.map((ele) => ele.rightIds)
                    ?.at(0)
                    ?.includes("10") && (
                    <button
                      type="button"
                      class="SubmitBtn"
                      onClick={() => handleViewExport("pdf")}
                    >
                      <i class="fa fa-file-pdf"></i>
                    </button>
                  )}
                </div>
              </div>
            )}
            {!disabled && (
              <div className="row">
                <div className="col-md-12">
                  <UploadMultipleDocuments
                    onFileSelect={handleFileUpload}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    uploadDocumentError={uploadDocumentError}
                    inputId="UploadWarehouseUser"
                  />
                  <div className="form-group my-3">
                    <label>Remarks</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData?.uploadDocumentRemarks}
                      onChange={handleChange}
                      name="uploadDocumentRemarks"
                    />
                  </div>
                </div>
              </div>
            )}

            {1 == isProfile ? (
              <>
                <div className="col-md-12 mt-2">
                  <input
                    type="checkbox"
                    checked={declarationCheck}
                    onChange={(e) =>
                      setDeclarationCheck(e.target.checked ? 1 : 0)
                    }
                  />
                  &nbsp; I hereby confirm that all details (editable and
                  non-editable) as displayed and updated on the screen herein
                  are correct. In case of any error, neither the Tea Board, its
                  service provider nor the bank would be responsible for any
                  consequences. System should not enable Update button until
                  user has not tick the checkbox of declaration/term & condition
                  on edit profile page.
                </div>
              </>
            ) : (
              ""
            )}

            {!disabled && (
              <div className="row mt-3">
                <div className="col-auto">
                  <div className="BtnGroup">
                    <button className={"SubmitBtn"} disabled={loading1}>
                      {loading1 ? "loading..." : "Update"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {1 == isProfile ? (
              <p className="Red mt-2 ml-3">
                Note: Kindly verify all your registered Warehouse Units are
                being displayed. In case of any discrepancy please contact
                Auction Organizer, and then only go ahead for updating. In case
                of any changes need to be done for non-editable field, kindly
                contact Tea board. Kindly select terms and condition in order to
                process User Profile & Bank Updating.
              </p>
            ) : (
              ""
            )}
          </form>
        </Modals>
      ) : (
        ""
      )}

      {/* View */}
      {/* {viewWarehouseModal ? (
        <Modals
          title={"View Warehouse User Registration"}
          show={false}
          handleClose={handleCloseViewWarehouseModal}
          size="xl"
          centered
        >
          <form onSubmit={handleSubmit}>
            <div className="row align-items-center">
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Address</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="address"
                    value={formData?.address}
                    onChange={handleChange}
                    maxLength={500}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Auction Center</label>
                  <label className="errorLabel"> * </label>

                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={onChangesAuctionCenterId}
                    onChange={handleAuctionCenter}
                    input={<OutlinedInput label="Tag" />}
                    renderValue={(selected) => selected.join(", ")}
                    className="w-100"
                  >
                    {getAllAuctionCenter?.map((AuctionCenter) => (
                      <MenuItem
                        key={AuctionCenter?.auctionCenterId}
                        value={AuctionCenter?.auctionCenterId} // Change to auctionCenterId
                      >
                        <Checkbox
                          checked={
                            onChangesAuctionCenterId.indexOf(
                              AuctionCenter?.auctionCenterId
                            ) > -1
                          }
                        />
                        <ListItemText
                          primary={AuctionCenter?.auctionCenterName}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                  {auctionCenterIdError && (
                    <p className="errorLabel">{auctionCenterIdError}</p>
                  )}
                </div>
              </div>

              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>City</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    value={formData?.city}
                    onChange={handleChange}
                    maxLength={50}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Contact Person</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="contactPerson"
                    value={formData && formData.contactPerson}
                    onChange={handleChange}
                    maxLength={100}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>E Mail</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                    maxLength={50}
                    disabled={disabled}
                  />
                </div>
              </div>
              {isEdit == true ? (
                <>
                  <div className="col-md-2">
                    <div className="FomrGroup">
                      <label>Entity Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="entityCode"
                        value={formData?.entityCode}
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Fax</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="fax"
                    value={formData?.fax}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>GST No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="gstNo"
                    value={formData?.gstNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Mobile No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobileNo"
                    value={formData?.mobileNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>PAN No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="panNo"
                    value={formData?.panNo}
                    onChange={handleChange}
                    maxLength={10}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Phone </label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="phoneNo"
                    value={formData?.phoneNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Short Name</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="shortName"
                    value={formData?.shortName}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>State Name</label>
                  <label className="errorLabel"> * </label>
                  <select
                    name="stateId"
                    value={formData?.stateId}
                    onChange={handleChange}
                    className="form-control select-form"
                    maxLength={500}
                    disabled={disabled}
                  >
                    <option>Select State</option>
                    {StateList?.map((StateList, index) => (
                      <option key={index} value={StateList.stateId}>
                        {StateList.stateName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>State Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="StateCode"
                    value={StateCode}
                    onChange={handleChange}
                    disabled
                  />
                </div>
              </div>

              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Tax Id No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="taxIdentityNo"
                    value={formData?.taxIdentityNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>

              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Teaboard Reg No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="teaBoardRegistrationNo"
                    value={formData?.teaBoardRegistrationNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Ware House Code</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="wareHouseCode"
                    value={formData?.wareHouseCode}
                    onChange={handleChange}
                    maxLength={10}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Ware House Name</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="wareHouseName"
                    value={formData?.wareHouseName}
                    onChange={handleChange}
                    maxLength={50}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="FomrGroup">
                  <label>Ware House License No</label>
                  <label className="errorLabel"> * </label>
                  <input
                    type="text"
                    className="form-control"
                    name="wareHouseLicenseNo"
                    value={formData?.wareHouseLicenseNo}
                    onChange={handleChange}
                    maxLength={15}
                    disabled={disabled}
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="FormGroup">
                  <label>IRN Eligibility (Turnover Exceeds 5 CR)</label>
                  <select
                    className="form-control select-form"
                    value={irnEligibility}
                    onChange={(e) => setIrnEligibility(e.target.value)}
                    disabled={true}
                  >
                    <option value={1}>Yes</option>
                    <option value={0}>No</option>
                  </select>
                </div>
              </div>

              {isEdit == true && (
                <div className="col-auto">
                  <div className="FomrGroup">
                    <label>Status</label>

                    <div className="d-flex CheckboxGroup">
                      <>
                        <div className="d-flex">
                          <div class="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isActive"
                              value={1}
                              onChange={handleChange}
                              checked={formData?.isActive === 1}
                            />
                            <label className="form-check-label">Active</label>
                          </div>
                          &nbsp;&nbsp;
                          <div class="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isActive"
                              value={2}
                              onChange={handleChange}
                              checked={formData?.isActive === 2}
                            />
                            <label className="form-check-label">Inactive</label>
                          </div>
                          &nbsp;&nbsp;
                          <div class="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="isActive"
                              value={3}
                              onChange={handleChange}
                              checked={formData?.isActive === 3}
                            />
                            <label className="form-check-label">Suspend</label>
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              )}

            </div>
            <div className="col-6">
              {auctioneerGstDtoList?.length > 0 ? (
                <>
                  <div className="row">
                    <div className="col-12">
                      {auctioneerGstDtoList &&
                        auctioneerGstDtoList.map((data, index) => (
                          <>
                            {!data.statePresent ? (
                              <div className="GSTBox">
                                <div className="row mt-2">
                                  <div className="col-md-3">
                                    <div className="FormGroup">
                                      <label>Sr No.</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={index + 1}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-3">
                                    <div className="FormGroup">
                                      <label>State</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={data?.stateName}
                                        disabled={true}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-3">
                                    <div className="FormGroup">
                                      <label>GSTNo</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={data?.gstNo}
                                        onChange={(e) =>
                                          tempAuctionCenterDataChange(
                                            "gstNo",
                                            e.target.value,
                                            data.stateId
                                          )
                                        }
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="FormGroup">
                                      <label> Address</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={data?.address}
                                        onChange={(e) =>
                                          tempAuctionCenterDataChange(
                                            "address",
                                            e.target.value,
                                            data.stateId
                                          )
                                        }
                                        disabled={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="row">
              <div className="col-md-12">
                <UploadMultipleDocuments
                  onFileSelect={handleFileUpload}
                  uploadedFiles={uploadedFiles}
                  setUploadedFiles={setUploadedFiles}
                  uploadDocumentError={uploadDocumentError}
                  inputId="UploadWarehouseUser"
                />
                <div className="form-group my-3">
                  <label>Remarks</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData?.uploadDocumentRemarks}
                    onChange={handleChange}
                    name="uploadDocumentRemarks"
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-auto">
                <div className="BtnGroup">
                  {childUser
                    .filter((user) => user.linkId === 26)
                    ?.map((ele) => ele.rightIds)
                    ?.at(0)
                    ?.includes("9") && (
                      <button
                        class="SubmitBtn"
                        type="button"
                        onClick={() => handleViewExport("excel")}
                      >
                        <i class="fa fa-file-excel"></i>
                      </button>
                    )}

                  {childUser
                    .filter((user) => user.linkId === 26)
                    ?.map((ele) => ele.rightIds)
                    ?.at(0)
                    ?.includes("8") && (
                      <button
                        class="SubmitBtn"
                        type="button"
                        onClick={() => handleViewExport("pdf")}
                      >
                        <i class="fa fa-file-pdf"></i>
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </Modals>
      ) : (
        ""
      )} */}

      {/* Manage & Search */}
      {modalRight
        ?.map((ele) => ele.rightIds)
        ?.at(0)
        ?.includes("12") && (
        <Accordion
          expanded={expanded === "panel2"}
          className={`${expanded === "panel2" ? "active" : ""}`}
          onChange={handleChangeExpand("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>Manage Warehouse User </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className="row align-items-center">
                <div className="col-md-3">
                  <div className="FomrGroup">
                    <label>Ware House Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="userCode"
                      value={searchData.userCode}
                      onChange={handleSearchWarehouse}
                    />
                  </div>
                </div>
                {userRoleCode === "TEABOARDUSER" && (
                  <>
                    <div className="col-md-3">
                      <div className="FomrGroup">
                        <label>Contact Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contactPerson"
                          value={searchData.contactPerson}
                          onChange={handleSearchWarehouse}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="col-md-3">
                  <div className="FomrGroup">
                    <label>Ware House Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="userName"
                      value={searchData.userName}
                      onChange={handleSearchWarehouse}
                    />
                  </div>
                </div>

                {userRoleCode === "TEABOARDUSER" && (
                  <>
                    <div className="col-md-3">
                      <div className="FormGroup">
                        <label>Tea Board Registration Certificate Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="teaBoardRegistrationCertificate"
                          value={searchData.teaBoardRegistrationCertificate}
                          onChange={handleSearchWarehouse}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="FormGroup">
                        <label>Email ID</label>
                        <input
                          type="text"
                          className="form-control"
                          name="email"
                          value={searchData.email}
                          onChange={handleSearchWarehouse}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="FormGroup">
                        <label>GST Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="gstNo"
                          value={searchData.gstNo}
                          onChange={handleSearchWarehouse}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="FormGroup">
                        <label>PAN Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="panNo"
                          value={searchData.panNo}
                          onChange={handleSearchWarehouse}
                        />
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="FormGroup">
                        <label>Auction Center</label>
                        <select
                          className="form-control"
                          name="auctioncenterIdAbc"
                          value={searchData.auctioncenterIdAbc}
                          onChange={handleSearchWarehouse}
                        >
                          <option value="">All</option>
                          {auctionCenterLists?.map((ele) => (
                            <option
                              key={ele.auctionCenterId}
                              value={ele.auctionCenterId}
                            >
                              {ele.auctionCenterName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </>
                )}

                <div className="col-md-3">
                  <div className="FomrGroup">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="isActive"
                      value={searchData.isActive}
                      onChange={handleSearchWarehouse}
                    >
                      <option value="">Select status</option>
                      <option value={1}>Active</option>
                      <option value={2}>Inactive</option>
                      <option value={3}>Suspend</option>
                    </select>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="BtnGroup">
                    <button
                      className="SubmitBtn"
                      onClick={() => handleSearch()}
                    >
                      Search
                    </button>
                    <button
                      className="SubmitBtn"
                      onClick={() => ClearSearch()}
                      type="button"
                    >
                      Clear
                    </button>

                    <button
                      class="SubmitBtn"
                      type="button"
                      onClick={() => handleViewExport("excel")}
                    >
                      <i class="fa fa-file-excel"></i>
                    </button>

                    <button
                      class="SubmitBtn"
                      type="button"
                      onClick={() => handleViewExport("pdf")}
                    >
                      <i class="fa fa-file-pdf"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12">
                  <div className="TableBox">
                    <table className="table">
                      <thead>
                        <tr>
                          <th rowSpan={2}>Ware House Code</th>
                          <th rowSpan={2}>Contact Name</th>
                          <th rowSpan={2}>Ware House Name</th>
                          <th rowSpan={2}>
                            Tea Board Registration Certificate Number
                          </th>
                          <th colSpan={3} className="text-center">
                            Contact Detail
                          </th>
                          <th colSpan={2} className="text-center">
                            Tax Detail
                          </th>
                          <th rowSpan={2}>Status</th>
                          <th rowSpan={2}>Action</th>
                        </tr>
                        <tr>
                          <th className="text-center">Phone Number</th>
                          <th className="text-center">Mobile Number </th>
                          <th className="text-center">Email ID</th>
                          <th className="text-center">GST Number</th>
                          <th className="text-center">PAN Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loader ? (
                          <>
                            <div className="">
                              <ThreeDots
                                visible={true}
                                height="80"
                                width="80"
                                color="#4fa94d"
                                radius="9"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                            </div>
                          </>
                        ) : 204 == getUserDataAll.statusCode ? (
                          <tr>
                            <td colSpan={11}>
                              <div className="NoData">No Records Found</div>
                            </td>
                          </tr>
                        ) : RegUsers?.length > 0 ? (
                          <>
                            {RegUsers?.map((warehouse, index) => {
                              const auctionCenter =
                                warehouse?.auctionCenterGstDtos?.length > 0
                                  ? warehouse?.auctionCenterGstDtos
                                  : {};
                              return (
                                <tr key={warehouse.wareHouseUserRegId}>
                                  <td>{warehouse.userCode}</td>
                                  <td>{warehouse.contactPersonName}</td>
                                  <td>{warehouse.userName}</td>
                                  <td>
                                    {" "}
                                    {auctionCenter?.map((x) => {
                                      return (
                                        <>
                                          &nbsp;
                                          {x.teaBoardRegistrationCertificate}
                                          <br />
                                        </>
                                      );
                                    })}
                                  </td>
                                  <td className="Phone">
                                    {auctionCenter?.map((x) => {
                                      return (
                                        <>
                                          <i className="fa fa-phone"></i> &nbsp;
                                          {x.phoneNo}
                                          <br />
                                        </>
                                      );
                                    })}
                                  </td>
                                  <td className="Mobile">
                                    {auctionCenter?.map((x) => {
                                      return (
                                        <>
                                          <i className="fas fa-mobile-alt"></i>{" "}
                                          &nbsp;
                                          {x.mobileNo}
                                          <br />
                                        </>
                                      );
                                    })}
                                  </td>
                                  <td className="Email">
                                    {auctionCenter?.map((x) => {
                                      return (
                                        <>
                                          <i className="fa fa-envelope"></i>{" "}
                                          &nbsp;
                                          {x.emailId}
                                          <br />
                                        </>
                                      );
                                    })}
                                  </td>
                                  <td>
                                    {auctionCenter?.map((x) => {
                                      return (
                                        <>
                                          {x.gstNo}
                                          <br />
                                        </>
                                      );
                                    })}
                                  </td>
                                  <td>{warehouse.panNo}</td>

                                  <td
                                    className={`Status ${
                                      warehouse.isActive == 1
                                        ? "Active"
                                        : warehouse.isActive == 2
                                        ? "Inactive"
                                        : warehouse.isActive === 3
                                        ? "Suspend"
                                        : ""
                                    }`}
                                  >
                                    {warehouse.isActive == 1
                                      ? "Active"
                                      : warehouse.isActive == 2
                                      ? "Inactive"
                                      : warehouse.isActive == 3
                                      ? "Suspend"
                                      : ""}
                                  </td>
                                  <td className="Action">
                                    <>
                                      {modalRight
                                        ?.map((ele) => ele.rightIds)
                                        ?.at(0)
                                        ?.includes("2") &&
                                        RegUsers[index].isActive !== 3 && (
                                          <Tooltip title="Edit" placement="top">
                                            <i
                                              className="fa fa-edit"
                                              onClick={() =>
                                                EditUserData(
                                                  warehouse.wareHouseUserId,
                                                  1
                                                )
                                              }
                                            ></i>
                                          </Tooltip>
                                        )}

                                      {modalRight
                                        ?.map((ele) => ele.rightIds)
                                        ?.at(0)
                                        ?.includes("3") && (
                                        <Tooltip title="View" placement="top">
                                          <i
                                            className="fa fa-eye"
                                            onClick={() =>
                                              ViewUserData(
                                                warehouse.wareHouseUserId,
                                                1
                                              )
                                            }
                                          ></i>
                                        </Tooltip>
                                      )}
                                      {modalRight
                                        ?.map((ele) => ele.rightIds)
                                        ?.at(0)
                                        ?.includes("4") && (
                                        <Tooltip
                                          title="History"
                                          placement="top"
                                        >
                                          <i
                                            className="fa fa-history"
                                            onClick={() =>
                                              ShowWarehouseHistory(
                                                warehouse.wareHouseUserId
                                              )
                                            }
                                          ></i>
                                        </Tooltip>
                                      )}

                                      {/* {childUser.some(
                                        (user) => user.linkId === 26
                                      ) && (
                                        <Tooltip title="Add" placement="top">
                                          <i
                                            className="fa fa-plus"
                                            onClick={() =>
                                              AddNewSubUser(
                                                warehouse.wareHouseUserRegId
                                              )
                                            }
                                          ></i>
                                        </Tooltip>
                                      )} */}

                                      {modalRight
                                        ?.map((ele) => ele.rightIds)
                                        ?.at(0)
                                        ?.includes("84") && (
                                        <>
                                          <Tooltip
                                            title="Reset Password"
                                            placement="top"
                                          >
                                            <i
                                              className="fa fa-key"
                                              onClick={() =>
                                                handleResetPassClick(
                                                  warehouse.wareHouseUserId
                                                )
                                              }
                                            ></i>
                                          </Tooltip>
                                        </>
                                      )}

                                      {modalRight
                                        ?.map((ele) => ele.rightIds)
                                        ?.at(0)
                                        ?.includes("80") &&
                                        RegUsers[index].isActive !== 3 && (
                                          <Tooltip title="Add" placement="top">
                                            <i
                                              className="fa fa-plus"
                                              onClick={() =>
                                                AddNewSubUser(
                                                  warehouse.wareHouseUserId
                                                )
                                              }
                                            ></i>
                                          </Tooltip>
                                        )}
                                    </>
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                  <div className="BtnGroup text-center ">
                    <button
                      class="SubmitBtn"
                      onClick={handleViewMore}
                      disabled={
                        !RegUsers ||
                        RegUsers.length % 20 !== 0 ||
                        RegUsers.length <= 0 ||
                        loader
                      }
                    >
                      View More
                    </button>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}

      {/* Upload Document */}
      {modalRight
        ?.map((ele) => ele.rightIds)
        ?.at(0)
        ?.includes("6") && (
        <Accordion
          expanded={expanded === "panel3"}
          className={`${expanded === "panel3" ? "active" : ""}`}
          onChange={handleChangeExpand("panel3")}
          TransitionProps={{ unmountOnExit: true }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Uploaded Document</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div className="TableBox">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Warehouse Name</th>
                      <th>Document Brief/Remarks</th>
                      <th>Document upload date and time</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {UploadedDocuemnt?.length > 0 ? (
                      <>
                        {UploadedDocuemnt &&
                          UploadedDocuemnt.map((document, index) => (
                            <tr key={document.id}>
                              <td>{index + 1}</td>
                              <td>{document.fieldValue}</td>
                              <td>{document.uploadDocumentRemarks}</td>
                              <td>{document.documentUploadTime}</td>
                              <td className="Action">
                                <>
                                  {modalRight
                                    ?.map((ele) => ele.rightIds)
                                    ?.at(0)
                                    ?.includes("7") && (
                                    <i
                                      className="fa fa-download"
                                      onClick={() => {
                                        handleDownloadClick(
                                          document.uploadDocumentConfId,
                                          "download"
                                        );
                                        handleDownloadPDF();
                                      }}
                                    ></i>
                                  )}
                                  {modalRight
                                    ?.map((ele) => ele.rightIds)
                                    ?.at(0)
                                    ?.includes("3") && (
                                    <i
                                      className="fa fa-eye"
                                      title="Preview"
                                      onClick={() => {
                                        handleDownloadClick(
                                          document.uploadDocumentConfId,
                                          "preview"
                                        );
                                        handleDownloadPDF();
                                      }}
                                    ></i>
                                  )}
                                </>
                              </td>
                            </tr>
                          ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={4}>
                            {loader ? (
                              <>
                                <div className="">
                                  <ThreeDots
                                    visible={true}
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    radius="9"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="NoData">No Data</div>
                              </>
                            )}
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}

      {/* Warehouse History */}
      {showmodalWarehouseHistory && (
        <Modal
          show={showmodalWarehouseHistory}
          onHide={hideWarehouseHistory}
          size="xl"
          centered
        >
          <Modal.Header>
            <Modal.Title>Warehouse History</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={() => hideWarehouseHistory()}
            ></i>
          </Modal.Header>
          <Modal.Body>
            <WarehouseHistory />
          </Modal.Body>
        </Modal>
      )}

      {/* Warehouse Unit */}
      {showmodal && (
        <Modal show={showmodal} onHide={SubUSerClose} size="xl" centered>
          <Modal.Header>
            <Modal.Title>Warehouse Unit Registration</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={() => CloseUnitModal()}
            ></i>
          </Modal.Header>
          <Modal.Body>
            {/* Warehouse Unit Create */}
            {childUser
              .filter((user) => user.linkId === 26)
              ?.map((ele) => ele.rightIds)
              ?.at(0)
              ?.includes("1") && (
              <Accordion
                expanded={expandedSub === "panel1"}
                className={`${expandedSub === "panel1" ? "active" : ""}`}
                onChange={handleChangeExpandSub("panel1")}
                TransitionProps={{ unmountOnExit: true }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Create Warehouse Unit Registration</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <form onSubmit={handleSubmitForUnit}>
                      <div className="row align-items-center">
                        <div className="col-md-2 d-none">
                          <div className="FomrGroup">
                            <label>wareHouseUserRegId</label>
                            <input
                              type="text"
                              className="form-control"
                              name="wareHouseUserRegId"
                              value={formDataUnit?.wareHouseUserRegId}
                              maxLength={500}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-2 d-none">
                          <div className="FomrGroup">
                            <label>wareHouseUserRegId</label>
                            <input
                              type="text"
                              className="form-control"
                              name="wareHouseUserRegId"
                              value={formDataUnit?.wareHouseUserRegId}
                              maxLength={500}
                              disabled
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Auction Center </label>
                            <select
                              className="form-control select-form"
                              value={formDataUnit?.auctionCenterId}
                              onChange={(e) => handleAuctionCenterChange(e)}
                              // disabled={true}
                            >
                              <option value="0">
                                {" "}
                                Please Select Auction Center
                              </option>
                              {auctionCenterLists?.map((ele, index) => (
                                <option value={ele.auctionCenterId} key={index}>
                                  {ele.auctionCenterName}
                                </option>
                              ))}
                              {/* <option value={1}>Yes</option> */}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>GST NO</label>
                            <input
                              type="text"
                              className="form-control"
                              name="address"
                              value={formDataUnit?.gstNo}
                              maxLength={500}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Address</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="address"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.address}
                              maxLength={500}
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>City</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.city}
                              maxLength={50}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Contact Person</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="contactPerson"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formData?.contactPerson}
                              maxLength={100}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Primary Email ID</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="emailId"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.emailId}
                              maxLength={50}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Entity Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="entityCode"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formData?.entityCode}
                            />
                          </div>
                        </div> */}
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Fax</label>

                            <input
                              type="text"
                              className="form-control"
                              name="fax"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.fax}
                              maxLength={15}
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>CIN number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="cinNo"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.cinNo}
                              maxLength={15}
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Mobile No</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="mobileNo"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.mobileNo}
                              maxLength={15}
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Phone: </label>
                            <input
                              type="text"
                              className="form-control"
                              name="phoneNo"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.phoneNo}
                              maxLength={15}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Short Name</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="shortName"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.shortName}
                              maxLength={50}
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>
                              Center Wise Tea board Rag. No/ Ware House License
                              No
                            </label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="teaBoardRegistrationNo"
                              onChange={handleChangeWareHouseRegDetails}
                              value={formDataUnit?.teaBoardRegistrationNo}
                              maxLength={50}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Ware House Unit Code</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="wareHouseUnitCode"
                              value={formDataUnit?.wareHouseUnitCode}
                              onChange={handleChangeForUnit}
                              maxLength={50}
                              disabled={warehouseDisabled}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Ware House Unit Name</label>
                            <label className="errorLabel"> * </label>
                            <input
                              type="text"
                              className="form-control"
                              name="wareHouseUnitName"
                              value={formDataUnit?.wareHouseUnitName}
                              onChange={handleChangeForUnit}
                              maxLength={50}
                              disabled={warehouseDisabled}
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Ware House License No</label>
                            <input
                              type="text"
                              className="form-control"
                              name="wareHouseLicenseNo"
                              value={formDataUnit?.wareHouseLicenseNo}
                              maxLength={50}
                              disabled
                            />
                          </div>
                        </div> */}

                        {isUnitEdit && (
                          <div className="col-auto">
                            <div className="FomrGroup">
                              <label>Status</label>

                              <div className="d-flex CheckboxGroup">
                                <div className="d-flex">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="isActive"
                                      value={1}
                                      onChange={handleChangeForUnit}
                                      checked={formDataUnit?.isActive == 1}
                                    />
                                    <label className="form-check-label">
                                      Active
                                    </label>
                                  </div>
                                  &nbsp;&nbsp;
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="isActive"
                                      value={2}
                                      onChange={handleChangeForUnit}
                                      checked={formDataUnit?.isActive == 2}
                                    />
                                    <label className="form-check-label">
                                      Inactive
                                    </label>
                                  </div>
                                  &nbsp;&nbsp;
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="isActive"
                                      value={3}
                                      onChange={handleChangeForUnit}
                                      checked={formDataUnit?.isActive == 3}
                                    />
                                    <label className="form-check-label">
                                      Suspend
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <UploadMultipleDocuments
                            onFileSelect={handleFileUploadForUnit}
                            uploadedFiles={uploadedFilesUnit}
                            setUploadedFiles={setUploadedFilesUnit}
                            uploadDocumentError={uploadDocumentError}
                            inputId="UploadWarehouseUnit"
                          />
                          <div className="form-group my-3">
                            <label>Remarks</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={handleChangeForUnit}
                              value={formDataUnit?.uploadDocumentRemarks}
                              name="uploadDocumentRemarks"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="BtnGroup">
                            <button className={"SubmitBtn"} disabled={loading1}>
                              {loading1 ? "loading..." : "Submit"}
                            </button>
                            <button
                              className="SubmitBtn"
                              type="button"
                              onClick={() => resetFormUnit()}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )}

            {/* Warehouse Unit Edit */}
            {editWarehouseUnitModal ? (
              <Modals
                title={"Edit Warehouse Unit"}
                show={editWarehouseUnitModal}
                handleClose={handleCloseEditWarehouseUnitModal}
                size="xl"
                centered
              >
                <form onSubmit={handleSubmitForUnit}>
                  <div className="row align-items-center">
                    <div className="col-md-2 d-none">
                      <div className="FomrGroup">
                        <label>wareHouseUserRegId</label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseUserRegId"
                          value={formDataUnit?.wareHouseUserRegId}
                          maxLength={500}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>GST No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={formDataUnit?.gstNo}
                          maxLength={500}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Address</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={formDataUnit?.address}
                          onChange={handleFormDataUnitChange}
                          maxLength={500}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>City</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="city"
                          value={formDataUnit?.city}
                          onChange={handleFormDataUnitChange}
                          maxLength={50}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Contact Person</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="contactPerson"
                          value={formDataUnit?.contactPerson}
                          maxLength={100}
                          onChange={handleFormDataUnitChange}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Primary Email ID</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="emailId"
                          value={formDataUnit?.emailId}
                          onChange={handleFormDataUnitChange}
                          maxLength={50}
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Entity Code</label>
                        <input
                          type="text"
                          className="form-control"
                          name="entityCode"
                          value={formDataUnit?.entityCode}
                          disabled
                        />
                      </div>
                    </div> */}
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Fax</label>
                        <input
                          type="text"
                          className="form-control"
                          name="fax"
                          value={formDataUnit?.fax}
                          onChange={handleFormDataUnitChange}
                          maxLength={15}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>CIN number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="cinNo"
                          onChange={handleChangeWareHouseRegDetails}
                          value={formDataUnit?.cinNo}
                          maxLength={15}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Mobile No</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="mobileNo"
                          value={formDataUnit?.mobileNo}
                          onChange={handleFormDataUnitChange}
                          maxLength={15}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Phone: </label>
                        <input
                          type="text"
                          className="form-control"
                          name="phoneNo"
                          value={formDataUnit?.phoneNo}
                          onChange={handleFormDataUnitChange}
                          maxLength={15}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Short Name</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="shortName"
                          value={formDataUnit?.shortName}
                          onChange={handleFormDataUnitChange}
                          maxLength={50}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Teaboard Reg No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="teaBoardRegistrationNo"
                          value={formDataUnit?.teaBoardRegistrationNo}
                          onChange={handleFormDataUnitChange}
                          maxLength={50}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Ware House Unit Code</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseUnitCode"
                          value={formDataUnit?.wareHouseUnitCode}
                          onChange={handleChangeForUnit}
                          maxLength={50}
                          disabled={warehouseDisabled}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Ware House Unit Name</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseUnitName"
                          value={formDataUnit?.wareHouseUnitName}
                          onChange={handleChangeForUnit}
                          maxLength={50}
                          disabled={warehouseDisabled}
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Ware House License No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseLicenseNo"
                          value={formDataUnit?.wareHouseLicenseNo}
                          maxLength={50}
                          disabled
                        />
                      </div>
                    </div> */}

                    {isUnitEdit && (
                      <div className="col-auto">
                        <div className="FomrGroup">
                          <label>Status</label>

                          <div className="d-flex CheckboxGroup">
                            <div className="d-flex">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={1}
                                  onChange={handleChangeForUnit}
                                  checked={formDataUnit?.isActive == 1}
                                />
                                <label className="form-check-label">
                                  Active
                                </label>
                              </div>
                              &nbsp;&nbsp;
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={2}
                                  onChange={handleChangeForUnit}
                                  checked={formDataUnit?.isActive == 2}
                                />
                                <label className="form-check-label">
                                  Inactive
                                </label>
                              </div>
                              &nbsp;&nbsp;
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={3}
                                  onChange={handleChangeForUnit}
                                  checked={formDataUnit?.isActive == 3}
                                />
                                <label className="form-check-label">
                                  Suspend
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <UploadMultipleDocuments
                        onFileSelect={handleFileUploadForUnit}
                        uploadedFiles={uploadedFilesUnit}
                        setUploadedFiles={setUploadedFilesUnit}
                        uploadDocumentError={uploadDocumentError}
                        inputId="UploadWarehouseUnit"
                      />
                      <div className="form-group my-3">
                        <label>Remarks</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={handleChangeForUnit}
                          value={formDataUnit?.uploadDocumentRemarks}
                          name="uploadDocumentRemarks"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="BtnGroup">
                        <button
                          className={"SubmitBtn"}
                          onClick={() => SaveUpdatedForUnit()}
                          disabled={loading1}
                        >
                          {loading1 ? "loading..." : "Update"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Modals>
            ) : (
              ""
            )}

            {/* Warehouse Unit View */}
            {viewWarehouseUnitModal ? (
              <Modals
                title={"View Warehouse Unit"}
                show={viewWarehouseUnitModal}
                handleClose={handleCloseViewWarehouseUnitModal}
                size="xl"
                centered
              >
                {" "}
                <form onSubmit={handleSubmitForUnit}>
                  <div className="row align-items-center">
                    <div className="col-md-2 d-none">
                      <div className="FomrGroup">
                        <label>wareHouseUserRegId</label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseUserRegId"
                          value={formDataUnit?.wareHouseUserRegId}
                          maxLength={500}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Address</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={formDataUnit?.address}
                          maxLength={500}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>City</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="city"
                          value={formDataUnit?.city}
                          maxLength={50}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Contact Person</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="contactPerson"
                          value={formDataUnit?.contactPerson}
                          maxLength={100}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Primary Email ID</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="email"
                          value={formDataUnit?.emailId}
                          maxLength={50}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Fax</label>
                        <input
                          type="text"
                          className="form-control"
                          name="fax"
                          value={formDataUnit?.fax}
                          maxLength={15}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Mobile No</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="mobileNo"
                          value={formDataUnit?.mobileNo}
                          maxLength={15}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Phone: </label>
                        <input
                          type="text"
                          className="form-control"
                          name="phoneNo"
                          value={formDataUnit?.phoneNo}
                          maxLength={15}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Short Name</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="shortName"
                          value={formDataUnit?.shortName}
                          maxLength={50}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Teaboard Reg No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="teaBoardRegistrationNo"
                          value={formDataUnit?.teaBoardRegistrationNo}
                          maxLength={50}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Ware House Unit Code</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseUnitCode"
                          value={formDataUnit?.wareHouseUnitCode}
                          onChange={handleChangeForUnit}
                          maxLength={50}
                          disabled={warehouseDisabled}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Ware House Unit Name</label>
                        <label className="errorLabel"> * </label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseUnitName"
                          value={formDataUnit?.wareHouseUnitName}
                          onChange={handleChangeForUnit}
                          maxLength={50}
                          disabled={warehouseDisabled}
                        />
                      </div>
                    </div>
                    {/* <div className="col-md-2">
                      <div className="FomrGroup">
                        <label>Ware House License No</label>
                        <input
                          type="text"
                          className="form-control"
                          name="wareHouseLicenseNo"
                          value={formDataUnit?.wareHouseLicenseNo}
                          maxLength={50}
                          disabled
                        />
                      </div>
                    </div> */}

                    {isUnitEdit && (
                      <div className="col-auto">
                        <div className="FomrGroup">
                          <label>Status</label>

                          <div className="d-flex CheckboxGroup">
                            <div className="d-flex">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={1}
                                  onChange={handleChangeForUnit}
                                  checked={formDataUnit?.isActive == 1}
                                />
                                <label className="form-check-label">
                                  Active
                                </label>
                              </div>
                              &nbsp;&nbsp;
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={2}
                                  onChange={handleChangeForUnit}
                                  checked={formDataUnit?.isActive == 2}
                                />
                                <label className="form-check-label">
                                  Inactive
                                </label>
                              </div>
                              &nbsp;&nbsp;
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="isActive"
                                  value={3}
                                  onChange={handleChangeForUnit}
                                  checked={formDataUnit?.isActive == 3}
                                />
                                <label className="form-check-label">
                                  Suspend
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {/* <UploadMultipleDocuments
                        onFileSelect={handleFileUploadForUnit}
                        uploadedFiles={uploadedFilesUnit}
                        setUploadedFiles={setUploadedFilesUnit}
                        uploadDocumentError={uploadDocumentError}
                        inputId="UploadWarehouseUnit"
                      /> */}
                      <div className="form-group my-3">
                        <label>Remarks</label>
                        <input
                          disabled
                          type="text"
                          className="form-control"
                          onChange={handleChangeForUnit}
                          value={formDataUnit?.uploadDocumentRemarks}
                          name="uploadDocumentRemarks"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="BtnGroup">
                        <button
                          class="SubmitBtn"
                          type="button"
                          onClick={() => handleViewExport("excel")}
                        >
                          <i class="fa fa-file-excel"></i>
                        </button>
                        <button
                          class="SubmitBtn"
                          type="button"
                          onClick={() => handleViewExport("pdf")}
                        >
                          <i class="fa fa-file-pdf"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </Modals>
            ) : (
              ""
            )}

            {/* Warehouse Unit Manage & Search */}
            {childUser
              .filter((user) => user.linkId === 26)
              ?.map((ele) => ele.rightIds)
              ?.at(0)
              ?.includes("12") && (
              <Accordion
                expanded={expandedSub === "panel2"}
                className={`${expandedSub === "panel2" ? "active" : ""}`}
                onChange={handleChangeExpandSub("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography>Manage Warehouse Unit</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <form onSubmit={handleUnitSearchSubmit}>
                      <div className="row align-items-center">
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Ware House Unit Code</label>
                            <input
                              type="text"
                              className="form-control"
                              name="wareHouseUnitCode"
                              value={unitSearchData.wareHouseUnitCode}
                              onChange={handleSearchUnit}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Ware House Unit Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="wareHouseUnitName"
                              value={unitSearchData.wareHouseUnitName}
                              onChange={handleSearchUnit}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>
                              Tea Board Registration Certificate Number
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="teaBoardRegistrationNo"
                              value={unitSearchData.teaBoardRegistrationNo}
                              onChange={handleSearchUnit}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Email ID</label>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              value={unitSearchData.email}
                              onChange={handleSearchUnit}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>GST Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="gstNo"
                              value={unitSearchData.gstNo}
                              onChange={handleSearchUnit}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>PAN Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="panNo"
                              value={unitSearchData.panNo}
                              onChange={handleSearchUnit}
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="FomrGroup">
                            <label>Status</label>
                            <select
                              className="form-control select-form"
                              value={unitSearchData.Status}
                              onChange={handleSearchUnit}
                              name="status"
                            >
                              <option>Select Status</option>
                              {Status?.map((status, index) => (
                                <option value={status.id}>
                                  {status.status}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <div className="BtnGroup">
                            <button
                              className="SubmitBtn"
                              onClick={() => handleSearch()}
                            >
                              Search
                            </button>
                            <button
                              type="button"
                              className="SubmitBtn"
                              onClick={() => ClearUnitSearch()}
                            >
                              Clear
                            </button>
                          </div>
                        </div>

                        {isViewUnit == true ? (
                          <>
                            {childUser
                              .filter((user) => user.linkId === 26)
                              ?.map((ele) => ele.rightIds)
                              ?.at(0)
                              ?.includes("11") && (
                              <button
                                class="SubmitBtn"
                                onClick={() => handleUnitViewExport("excel")}
                              >
                                <i class="fa fa-file-excel"></i>
                              </button>
                            )}
                            {childUser
                              .filter((user) => user.linkId === 26)
                              ?.map((ele) => ele.rightIds)
                              ?.at(0)
                              ?.includes("10") && (
                              <button
                                class="SubmitBtn"
                                onClick={() => handleUnitViewExport("pdf")}
                              >
                                <i class="fa fa-file-pdf"></i>
                              </button>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </form>
                    <div className="row">
                      <div className="col-12">
                        <div className="TableBox">
                          <table className="table">
                            <thead>
                              <tr>
                                {/* <th rowSpan={2}>Sr.</th> */}
                                <th rowSpan={2}>Ware House Unit Code</th>
                                <th rowSpan={2}>Contact Name</th>
                                <th rowSpan={2}>Ware House Unit Name</th>
                                <th rowSpan={2}>
                                  Tea Board Registration Certificate Number
                                </th>

                                <th colSpan={3} className="text-center">
                                  Contact Detail
                                </th>
                                <th colSpan={2} className="text-center">
                                  Tax Detail
                                </th>
                                <th rowSpan={2}>Status</th>
                                <th rowSpan={2}>Action</th>
                              </tr>
                              <tr>
                                <th className="text-center">Phone Number</th>
                                <th className="text-center">Mobile Number</th>
                                <th className="text-center">Email ID</th>
                                <th className="text-center">GST Number</th>
                                <th className="text-center">PAN Number</th>
                              </tr>
                            </thead>

                            <tbody>
                              {loader ? (
                                <>
                                  <div className="">
                                    <ThreeDots
                                      visible={true}
                                      height="80"
                                      width="80"
                                      color="#4fa94d"
                                      radius="9"
                                      ariaLabel="three-dots-loading"
                                      wrapperStyle={{}}
                                      wrapperClass=""
                                    />
                                  </div>
                                </>
                              ) : 204 == SearchWareHouseUnitAll?.statusCode ? (
                                <tr>
                                  <td colSpan={11}>
                                    <div className="NoData">
                                      No Records Found
                                    </div>
                                  </td>
                                </tr>
                              ) : unitsearch?.length > 0 ? (
                                <>
                                  {unitsearch?.map((unit, index) => (
                                    <tr key={unit.id}>
                                      {/* <td>{index + 1}</td> */}
                                      <td>{unit.wareHouseUnitCode}</td>
                                      <td>{unit.contactPerson}</td>
                                      <td>{unit.wareHouseUnitName}</td>
                                      <td>{unit.teaBoardRegistrationNo}</td>

                                      <td className="Phone">
                                        <i className="fas fa-phone"></i>&nbsp;{" "}
                                        {unit.phoneNo}
                                      </td>
                                      <td className="Mobile">
                                        <i className="fa fa-mobile-alt"></i>
                                        &nbsp; {unit.mobileNo}
                                      </td>
                                      <td className="Email">
                                        <i className="fa fa-envelope"></i>&nbsp;{" "}
                                        {unit.email}
                                      </td>
                                      <td>{unit.gstNo}</td>
                                      <td>{unit.panNo}</td>
                                      <td
                                        className={`Status ${
                                          unit.isActive === 1
                                            ? "Active"
                                            : unit.isActive === 2
                                            ? "Inactive"
                                            : unit.isActive === 3
                                            ? "Suspend"
                                            : ""
                                        }`}
                                      >
                                        {unit.isActive === 1
                                          ? "Active"
                                          : unit.isActive === 2
                                          ? "Inactive"
                                          : unit.isActive === 3
                                          ? "Suspend"
                                          : ""}
                                      </td>
                                      <td className="Action">
                                        {childUser
                                          .filter((user) => user.linkId === 26)
                                          ?.map((ele) => ele.rightIds)
                                          ?.at(0)
                                          ?.includes("2") && (
                                          <Tooltip title="Edit" placement="top">
                                            <i
                                              className="fa fa-edit"
                                              onClick={() =>
                                                EditUnit(
                                                  unit.wareHouseunitRegId
                                                )
                                              }
                                            ></i>
                                          </Tooltip>
                                        )}

                                        {childUser
                                          .filter((user) => user.linkId === 26)
                                          ?.map((ele) => ele.rightIds)
                                          ?.at(0)
                                          ?.includes("3") && (
                                          <Tooltip title="View" placement="top">
                                            <i
                                              className="fa fa-eye"
                                              onClick={() =>
                                                ViewUniWareHouse(
                                                  unit.wareHouseunitRegId
                                                )
                                              }
                                            ></i>
                                          </Tooltip>
                                        )}

                                        {childUser
                                          .filter((user) => user.linkId === 26)
                                          ?.map((ele) => ele.rightIds)
                                          ?.at(0)
                                          ?.includes("4") && (
                                          <Tooltip
                                            title="History"
                                            placement="top"
                                          >
                                            <i
                                              className="fa fa-history"
                                              onClick={() =>
                                                ShowUnitHistory(
                                                  unit.wareHouseunitRegId
                                                )
                                              }
                                            ></i>
                                          </Tooltip>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )}

            {/* Warehouse Unit Upload Document */}
            {childUser
              .filter((user) => user.linkId === 26)
              ?.map((ele) => ele.rightIds)
              ?.at(0)
              ?.includes("6") && (
              <Accordion
                expanded={expandedSub === "panel3"}
                className={`${expandedSub === "panel3" ? "active" : ""}`}
                onChange={handleChangeExpandSub("panel3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3a-content"
                  id="panel3a-header"
                >
                  <Typography>Uploaded Document</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="TableBox">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Warehouse Unit Name</th>
                            <th>Document Brief/Remarks</th>
                            <th>Document upload date and time</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {unitDocument?.length > 0 ? (
                            <>
                              {unitDocument &&
                                unitDocument?.map((document, index) => (
                                  <tr key={document.id}>
                                    <td>{index + 1}</td>
                                    <td>{document.fieldValue}</td>
                                    <td>{document.uploadDocumentRemarks}</td>
                                    <td>{document.documentUploadTime}</td>
                                    <td className="Action">
                                      <i
                                        className="fa fa-eye"
                                        title="Preview"
                                      ></i>
                                      {childUser
                                        .filter((user) => user.linkId === 26)
                                        ?.map((ele) => ele.rightIds)
                                        ?.at(0)
                                        ?.includes("7") && (
                                        <i
                                          className="fa fa-download"
                                          onClick={() => {
                                            handleDownloadClick(
                                              document.uploadDocumentConfId
                                            );
                                            handleDownloadPDF();
                                          }}
                                        ></i>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </>
                          ) : (
                            <>
                              <tr>
                                <td colSpan={4}>
                                  {loader ? (
                                    <>
                                      <div className="">
                                        <ThreeDots
                                          visible={true}
                                          height="80"
                                          width="80"
                                          color="#4fa94d"
                                          radius="9"
                                          ariaLabel="three-dots-loading"
                                          wrapperStyle={{}}
                                          wrapperClass=""
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="NoData">No Data</div>
                                    </>
                                  )}
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )}
          </Modal.Body>
        </Modal>
      )}
      {previewDocumentContent != "" && "preview" == documentMode ? (
        <Modal
          show={previewModal}
          onHide={handleClosePreviewModal}
          size="lg"
          centered
        >
          <Modal.Header>
            <Modal.Title>Preview</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={handleClosePreviewModal}
            ></i>
          </Modal.Header>

          <Modal.Body>
            <Base64ToPDFPreview base64String={previewDocumentContent} />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
      {/* Warehouse Unit History */}
      {showmodalWarehouseUnitHistory && (
        <Modal
          show={showmodalWarehouseUnitHistory}
          onHide={hideUnitHistory}
          size="xl"
          centered
        >
          <Modal.Header>
            <Modal.Title>Warehouse Unit History</Modal.Title>
            <i
              className="fa fa-times CloseModal"
              onClick={() => hideUnitHistory()}
            ></i>
          </Modal.Header>
          <Modal.Body>
            <WarehouseUnitHistory />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default WarehouseUserRegistration;
